webpackJsonp([12],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(71)(__webpack_require__(328));

/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), intl$messageformat$$ = __webpack_require__(10), intl$relativeformat$$ = __webpack_require__(11), intl$format$cache$$ = __webpack_require__(42);
	
	// -----------------------------------------------------------------------------
	
	var typesSpec = {
	    locales: src$react$$["default"].PropTypes.oneOfType([
	        src$react$$["default"].PropTypes.string,
	        src$react$$["default"].PropTypes.array
	    ]),
	
	    formats : src$react$$["default"].PropTypes.object,
	    messages: src$react$$["default"].PropTypes.object
	};
	
	function assertIsDate(date, errMsg) {
	    // Determine if the `date` is valid by checking if it is finite, which is
	    // the same way that `Intl.DateTimeFormat#format()` checks.
	    if (!isFinite(date)) {
	        throw new TypeError(errMsg);
	    }
	}
	
	exports["default"] = {
	    statics: {
	        filterFormatOptions: function (obj, defaults) {
	            if (!defaults) { defaults = {}; }
	
	            return (this.formatOptions || []).reduce(function (opts, name) {
	                if (obj.hasOwnProperty(name)) {
	                    opts[name] = obj[name];
	                } else if (defaults.hasOwnProperty(name)) {
	                    opts[name] = defaults[name];
	                }
	
	                return opts;
	            }, {});
	        }
	    },
	
	    propTypes        : typesSpec,
	    contextTypes     : typesSpec,
	    childContextTypes: typesSpec,
	
	    getNumberFormat  : intl$format$cache$$["default"](Intl.NumberFormat),
	    getDateTimeFormat: intl$format$cache$$["default"](Intl.DateTimeFormat),
	    getMessageFormat : intl$format$cache$$["default"](intl$messageformat$$["default"]),
	    getRelativeFormat: intl$format$cache$$["default"](intl$relativeformat$$["default"]),
	
	    getChildContext: function () {
	        var context = this.context;
	        var props   = this.props;
	
	        return {
	            locales:  props.locales  || context.locales,
	            formats:  props.formats  || context.formats,
	            messages: props.messages || context.messages
	        };
	    },
	
	    formatDate: function (date, options) {
	        date = new Date(date);
	        assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
	        return this._format('date', date, options);
	    },
	
	    formatTime: function (date, options) {
	        date = new Date(date);
	        assertIsDate(date, 'A date or timestamp must be provided to formatTime()');
	        return this._format('time', date, options);
	    },
	
	    formatRelative: function (date, options, formatOptions) {
	        date = new Date(date);
	        assertIsDate(date, 'A date or timestamp must be provided to formatRelative()');
	        return this._format('relative', date, options, formatOptions);
	    },
	
	    formatNumber: function (num, options) {
	        return this._format('number', num, options);
	    },
	
	    formatMessage: function (message, values) {
	        var locales = this.props.locales || this.context.locales;
	        var formats = this.props.formats || this.context.formats;
	
	        // When `message` is a function, assume it's an IntlMessageFormat
	        // instance's `format()` method passed by reference, and call it. This
	        // is possible because its `this` will be pre-bound to the instance.
	        if (typeof message === 'function') {
	            return message(values);
	        }
	
	        if (typeof message === 'string') {
	            message = this.getMessageFormat(message, locales, formats);
	        }
	
	        return message.format(values);
	    },
	
	    getIntlMessage: function (path) {
	        var messages  = this.props.messages || this.context.messages;
	        var pathParts = path.split('.');
	
	        var message;
	
	        try {
	            message = pathParts.reduce(function (obj, pathPart) {
	                return obj[pathPart];
	            }, messages);
	        } finally {
	            if (message === undefined) {
	                throw new ReferenceError('Could not find Intl message: ' + path);
	            }
	        }
	
	        return message;
	    },
	
	    getNamedFormat: function (type, name) {
	        var formats = this.props.formats || this.context.formats;
	        var format  = null;
	
	        try {
	            format = formats[type][name];
	        } finally {
	            if (!format) {
	                throw new ReferenceError(
	                    'No ' + type + ' format named: ' + name
	                );
	            }
	        }
	
	        return format;
	    },
	
	    _format: function (type, value, options, formatOptions) {
	        var locales = this.props.locales || this.context.locales;
	
	        if (options && typeof options === 'string') {
	            options = this.getNamedFormat(type, options);
	        }
	
	        switch(type) {
	            case 'date':
	            case 'time':
	                return this.getDateTimeFormat(locales, options).format(value);
	            case 'number':
	                return this.getNumberFormat(locales, options).format(value);
	            case 'relative':
	                return this.getRelativeFormat(locales, options).format(value, formatOptions);
	            default:
	                throw new Error('Unrecognized format type: ' + type);
	        }
	    }
	};
	
	//# sourceMappingURL=mixin.js.map

/***/ },

/***/ 5:
/***/ function(module, exports) {

	/* global React */
	/* jshint esnext:true */
	
	// TODO: Remove the global `React` binding lookup once the ES6 Module Transpiler
	// supports external modules. This is a hack for now that provides the local
	// modules a referece to React.
	"use strict";
	exports["default"] = React;
	
	//# sourceMappingURL=react.js.map

/***/ },

/***/ 6:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* jshint node:true */
	'use strict';
	
	// Expose `React` as a global, because the ReactIntlMixin assumes it's global.
	var oldReact = global.React;
	global.React = __webpack_require__(1);
	
	// Require the lib and add all locale data to `ReactIntl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	var ReactIntl = __webpack_require__(41);
	__webpack_require__(46);
	
	// Export the Mixin as the default export for back-compat with v1.0.0. This will
	// be changed to simply re-exporting `ReactIntl` as the default export in v2.0.
	exports = module.exports = ReactIntl.IntlMixin;
	
	// Define non-enumerable expandos for each named export on the default export --
	// which is the Mixin for back-compat with v1.0.0.
	Object.keys(ReactIntl).forEach(function (namedExport) {
	    Object.defineProperty(exports, namedExport, {
	        enumerable: true,
	        value     : ReactIntl[namedExport]
	    });
	});
	
	// Put back `global.React` to how it was.
	if (oldReact) {
	    global.React = oldReact;
	} else {
	    // IE < 9 will throw when trying to delete something off the global object,
	    // `window`, so this does the next best thing as sets it to `undefined`.
	    try {
	        delete global.React;
	    } catch (e) {
	        global.React = undefined;
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 11:
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(31)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(45);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },

/***/ 23:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * CLDR JavaScript Library v0.5.4
	 * http://jquery.com/
	 *
	 * Copyright 2013 Rafael Xavier de Souza
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2020-10-22T15:56Z
	 */
	/*!
	 * CLDR JavaScript Library v0.5.4 2020-10-22T15:56Z MIT license © Rafael Xavier
	 * http://git.io/h4lmVg
	 */
	(function( root, factory ) {
	
		if ( true ) {
			// AMD.
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ( typeof module === "object" && typeof module.exports === "object" ) {
			// Node. CommonJS.
			module.exports = factory();
		} else {
			// Global
			root.Cldr = factory();
		}
	
	}( this, function() {
	
	
		var arrayIsArray = Array.isArray || function( obj ) {
			return Object.prototype.toString.call( obj ) === "[object Array]";
		};
	
	
	
	
		var pathNormalize = function( path, attributes ) {
			if ( arrayIsArray( path ) ) {
				path = path.join( "/" );
			}
			if ( typeof path !== "string" ) {
				throw new Error( "invalid path \"" + path + "\"" );
			}
			// 1: Ignore leading slash `/`
			// 2: Ignore leading `cldr/`
			path = path
				.replace( /^\// , "" ) /* 1 */
				.replace( /^cldr\// , "" ); /* 2 */
	
			// Replace {attribute}'s
			path = path.replace( /{[a-zA-Z]+}/g, function( name ) {
				name = name.replace( /^{([^}]*)}$/, "$1" );
				return attributes[ name ];
			});
	
			return path.split( "/" );
		};
	
	
	
	
		var arraySome = function( array, callback ) {
			var i, length;
			if ( array.some ) {
				return array.some( callback );
			}
			for ( i = 0, length = array.length; i < length; i++ ) {
				if ( callback( array[ i ], i, array ) ) {
					return true;
				}
			}
			return false;
		};
	
	
	
	
		/**
		 * Return the maximized language id as defined in
		 * http://www.unicode.org/reports/tr35/#Likely_Subtags
		 * 1. Canonicalize.
		 * 1.1 Make sure the input locale is in canonical form: uses the right
		 * separator, and has the right casing.
		 * TODO Right casing? What df? It seems languages are lowercase, scripts are
		 * Capitalized, territory is uppercase. I am leaving this as an exercise to
		 * the user.
		 *
		 * 1.2 Replace any deprecated subtags with their canonical values using the
		 * <alias> data in supplemental metadata. Use the first value in the
		 * replacement list, if it exists. Language tag replacements may have multiple
		 * parts, such as "sh" ➞ "sr_Latn" or mo" ➞ "ro_MD". In such a case, the
		 * original script and/or region are retained if there is one. Thus
		 * "sh_Arab_AQ" ➞ "sr_Arab_AQ", not "sr_Latn_AQ".
		 * TODO What <alias> data?
		 *
		 * 1.3 If the tag is grandfathered (see <variable id="$grandfathered"
		 * type="choice"> in the supplemental data), then return it.
		 * TODO grandfathered?
		 *
		 * 1.4 Remove the script code 'Zzzz' and the region code 'ZZ' if they occur.
		 * 1.5 Get the components of the cleaned-up source tag (languages, scripts,
		 * and regions), plus any variants and extensions.
		 * 2. Lookup. Lookup each of the following in order, and stop on the first
		 * match:
		 * 2.1 languages_scripts_regions
		 * 2.2 languages_regions
		 * 2.3 languages_scripts
		 * 2.4 languages
		 * 2.5 und_scripts
		 * 3. Return
		 * 3.1 If there is no match, either return an error value, or the match for
		 * "und" (in APIs where a valid language tag is required).
		 * 3.2 Otherwise there is a match = languagem_scriptm_regionm
		 * 3.3 Let xr = xs if xs is not empty, and xm otherwise.
		 * 3.4 Return the language tag composed of languager _ scriptr _ regionr +
		 * variants + extensions.
		 *
		 * @subtags [Array] normalized language id subtags tuple (see init.js).
		 */
		var coreLikelySubtags = function( Cldr, cldr, subtags, options ) {
			var match, matchFound,
				language = subtags[ 0 ],
				script = subtags[ 1 ],
				sep = Cldr.localeSep,
				territory = subtags[ 2 ],
				variants = subtags.slice( 3, 4 );
			options = options || {};
	
			// Skip if (language, script, territory) is not empty [3.3]
			if ( language !== "und" && script !== "Zzzz" && territory !== "ZZ" ) {
				return [ language, script, territory ].concat( variants );
			}
	
			// Skip if no supplemental likelySubtags data is present
			if ( typeof cldr.get( "supplemental/likelySubtags" ) === "undefined" ) {
				return;
			}
	
			// [2]
			matchFound = arraySome([
				[ language, script, territory ],
				[ language, territory ],
				[ language, script ],
				[ language ],
				[ "und", script ]
			], function( test ) {
				return match = !(/\b(Zzzz|ZZ)\b/).test( test.join( sep ) ) /* [1.4] */ && cldr.get( [ "supplemental/likelySubtags", test.join( sep ) ] );
			});
	
			// [3]
			if ( matchFound ) {
				// [3.2 .. 3.4]
				match = match.split( sep );
				return [
					language !== "und" ? language : match[ 0 ],
					script !== "Zzzz" ? script : match[ 1 ],
					territory !== "ZZ" ? territory : match[ 2 ]
				].concat( variants );
			} else if ( options.force ) {
				// [3.1.2]
				return cldr.get( "supplemental/likelySubtags/und" ).split( sep );
			} else {
				// [3.1.1]
				return;
			}
		};
	
	
	
		/**
		 * Given a locale, remove any fields that Add Likely Subtags would add.
		 * http://www.unicode.org/reports/tr35/#Likely_Subtags
		 * 1. First get max = AddLikelySubtags(inputLocale). If an error is signaled,
		 * return it.
		 * 2. Remove the variants from max.
		 * 3. Then for trial in {language, language _ region, language _ script}. If
		 * AddLikelySubtags(trial) = max, then return trial + variants.
		 * 4. If you do not get a match, return max + variants.
		 * 
		 * @maxLanguageId [Array] maxLanguageId tuple (see init.js).
		 */
		var coreRemoveLikelySubtags = function( Cldr, cldr, maxLanguageId ) {
			var match, matchFound,
				language = maxLanguageId[ 0 ],
				script = maxLanguageId[ 1 ],
				territory = maxLanguageId[ 2 ],
				variants = maxLanguageId[ 3 ];
	
			// [3]
			matchFound = arraySome([
				[ [ language, "Zzzz", "ZZ" ], [ language ] ],
				[ [ language, "Zzzz", territory ], [ language, territory ] ],
				[ [ language, script, "ZZ" ], [ language, script ] ]
			], function( test ) {
				var result = coreLikelySubtags( Cldr, cldr, test[ 0 ] );
				match = test[ 1 ];
				return result && result[ 0 ] === maxLanguageId[ 0 ] &&
					result[ 1 ] === maxLanguageId[ 1 ] &&
					result[ 2 ] === maxLanguageId[ 2 ];
			});
	
			if ( matchFound ) {
				if ( variants ) {
					match.push( variants );
				}
				return match;
			}
	
			// [4]
			return maxLanguageId;
		};
	
	
	
	
		/**
		 * subtags( locale )
		 *
		 * @locale [String]
		 */
		var coreSubtags = function( locale ) {
			var aux, unicodeLanguageId,
				subtags = [];
	
			locale = locale.replace( /_/, "-" );
	
			// Unicode locale extensions.
			aux = locale.split( "-u-" );
			if ( aux[ 1 ] ) {
				aux[ 1 ] = aux[ 1 ].split( "-t-" );
				locale = aux[ 0 ] + ( aux[ 1 ][ 1 ] ? "-t-" + aux[ 1 ][ 1 ] : "");
				subtags[ 4 /* unicodeLocaleExtensions */ ] = aux[ 1 ][ 0 ];
			}
	
			// TODO normalize transformed extensions. Currently, skipped.
			// subtags[ x ] = locale.split( "-t-" )[ 1 ];
			unicodeLanguageId = locale.split( "-t-" )[ 0 ];
	
			// unicode_language_id = "root"
			//   | unicode_language_subtag         
			//     (sep unicode_script_subtag)? 
			//     (sep unicode_region_subtag)?
			//     (sep unicode_variant_subtag)* ;
			//
			// Although unicode_language_subtag = alpha{2,8}, I'm using alpha{2,3}. Because, there's no language on CLDR lengthier than 3.
			aux = unicodeLanguageId.match( /^(([a-z]{2,3})(-([A-Z][a-z]{3}))?(-([A-Z]{2}|[0-9]{3}))?)((-([a-zA-Z0-9]{5,8}|[0-9][a-zA-Z0-9]{3}))*)$|^(root)$/ );
			if ( aux === null ) {
				return [ "und", "Zzzz", "ZZ" ];
			}
			subtags[ 0 /* language */ ] = aux[ 10 ] /* root */ || aux[ 2 ] || "und";
			subtags[ 1 /* script */ ] = aux[ 4 ] || "Zzzz";
			subtags[ 2 /* territory */ ] = aux[ 6 ] || "ZZ";
			if ( aux[ 7 ] && aux[ 7 ].length ) {
				subtags[ 3 /* variant */ ] = aux[ 7 ].slice( 1 ) /* remove leading "-" */;
			}
	
			// 0: language
			// 1: script
			// 2: territory (aka region)
			// 3: variant
			// 4: unicodeLocaleExtensions
			return subtags;
		};
	
	
	
	
		var arrayForEach = function( array, callback ) {
			var i, length;
			if ( array.forEach ) {
				return array.forEach( callback );
			}
			for ( i = 0, length = array.length; i < length; i++ ) {
				callback( array[ i ], i, array );
			}
		};
	
	
	
	
		/**
		 * bundleLookup( minLanguageId )
		 *
		 * @Cldr [Cldr class]
		 *
		 * @cldr [Cldr instance]
		 *
		 * @minLanguageId [String] requested languageId after applied remove likely subtags.
		 */
		var bundleLookup = function( Cldr, cldr, minLanguageId ) {
			var availableBundleMap = Cldr._availableBundleMap,
				availableBundleMapQueue = Cldr._availableBundleMapQueue;
	
			if ( availableBundleMapQueue.length ) {
				arrayForEach( availableBundleMapQueue, function( bundle, i ) {
					var existing, maxBundle, minBundle, subtags;
					subtags = coreSubtags( bundle );
					maxBundle = coreLikelySubtags( Cldr, cldr, subtags );
					if ( maxBundle === undefined ) {
						availableBundleMapQueue.splice( i, 1 );
						throw new Error( "Could not find likelySubtags for " + bundle );
					}
					minBundle = coreRemoveLikelySubtags( Cldr, cldr, maxBundle );
					minBundle = minBundle.join( Cldr.localeSep );
					existing = availableBundleMap[ minBundle ];
					if ( existing && existing.length < bundle.length ) {
						return;
					}
					availableBundleMap[ minBundle ] = bundle;
				});
				Cldr._availableBundleMapQueue = [];
			}
	
			return availableBundleMap[ minLanguageId ] || null;
		};
	
	
	
	
		var objectKeys = function( object ) {
			var i,
				result = [];
	
			if ( Object.keys ) {
				return Object.keys( object );
			}
	
			for ( i in object ) {
				result.push( i );
			}
	
			return result;
		};
	
	
	
	
		var createError = function( code, attributes ) {
			var error, message;
	
			message = code + ( attributes && JSON ? ": " + JSON.stringify( attributes ) : "" );
			error = new Error( message );
			error.code = code;
	
			// extend( error, attributes );
			arrayForEach( objectKeys( attributes ), function( attribute ) {
				error[ attribute ] = attributes[ attribute ];
			});
	
			return error;
		};
	
	
	
	
		var validate = function( code, check, attributes ) {
			if ( !check ) {
				throw createError( code, attributes );
			}
		};
	
	
	
	
		var validatePresence = function( value, name ) {
			validate( "E_MISSING_PARAMETER", typeof value !== "undefined", {
				name: name
			});
		};
	
	
	
	
		var validateType = function( value, name, check, expected ) {
			validate( "E_INVALID_PAR_TYPE", check, {
				expected: expected,
				name: name,
				value: value
			});
		};
	
	
	
	
		var validateTypePath = function( value, name ) {
			validateType( value, name, typeof value === "string" || arrayIsArray( value ), "String or Array" );
		};
	
	
	
	
		/**
		 * Function inspired by jQuery Core, but reduced to our use case.
		 */
		var isPlainObject = function( obj ) {
			return obj !== null && "" + obj === "[object Object]";
		};
	
	
	
	
		var validateTypePlainObject = function( value, name ) {
			validateType( value, name, typeof value === "undefined" || isPlainObject( value ), "Plain Object" );
		};
	
	
	
	
		var validateTypeString = function( value, name ) {
			validateType( value, name, typeof value === "string", "a string" );
		};
	
	
	
	
		// @path: normalized path
		var resourceGet = function( data, path ) {
			var i,
				node = data,
				length = path.length;
	
			for ( i = 0; i < length - 1; i++ ) {
				node = node[ path[ i ] ];
				if ( !node ) {
					return undefined;
				}
			}
			return node[ path[ i ] ];
		};
	
	
	
	
		/**
		 * setAvailableBundles( Cldr, json )
		 *
		 * @Cldr [Cldr class]
		 *
		 * @json resolved/unresolved cldr data.
		 *
		 * Set available bundles queue based on passed json CLDR data. Considers a bundle as any String at /main/{bundle}.
		 */
		var coreSetAvailableBundles = function( Cldr, json ) {
			var bundle,
				availableBundleMapQueue = Cldr._availableBundleMapQueue,
				main = resourceGet( json, [ "main" ] );
	
			if ( main ) {
				for ( bundle in main ) {
					if ( main.hasOwnProperty( bundle ) && bundle !== "root" &&
								availableBundleMapQueue.indexOf( bundle ) === -1 ) {
						availableBundleMapQueue.push( bundle );
					}
				}
			}
		};
	
	
	
		var alwaysArray = function( somethingOrArray ) {
			return arrayIsArray( somethingOrArray ) ?  somethingOrArray : [ somethingOrArray ];
		};
	
	
		var jsonMerge = (function() {
	
		// Returns new deeply merged JSON.
		//
		// Eg.
		// merge( { a: { b: 1, c: 2 } }, { a: { b: 3, d: 4 } } )
		// -> { a: { b: 3, c: 2, d: 4 } }
		//
		// @arguments JSON's
		// 
		var merge = function() {
			var destination = {},
				sources = [].slice.call( arguments, 0 );
			arrayForEach( sources, function( source ) {
				var prop;
				for ( prop in source ) {
					if ( prop in destination && typeof destination[ prop ] === "object" && !arrayIsArray( destination[ prop ] ) ) {
	
						// Merge Objects
						destination[ prop ] = merge( destination[ prop ], source[ prop ] );
	
					} else {
	
						// Set new values
						destination[ prop ] = source[ prop ];
	
					}
				}
			});
			return destination;
		};
	
		return merge;
	
	}());
	
	
		/**
		 * load( Cldr, source, jsons )
		 *
		 * @Cldr [Cldr class]
		 *
		 * @source [Object]
		 *
		 * @jsons [arguments]
		 */
		var coreLoad = function( Cldr, source, jsons ) {
			var i, j, json;
	
			validatePresence( jsons[ 0 ], "json" );
	
			// Support arbitrary parameters, e.g., `Cldr.load({...}, {...})`.
			for ( i = 0; i < jsons.length; i++ ) {
	
				// Support array parameters, e.g., `Cldr.load([{...}, {...}])`.
				json = alwaysArray( jsons[ i ] );
	
				for ( j = 0; j < json.length; j++ ) {
					validateTypePlainObject( json[ j ], "json" );
					source = jsonMerge( source, json[ j ] );
					coreSetAvailableBundles( Cldr, json[ j ] );
				}
			}
	
			return source;
		};
	
	
	
		var itemGetResolved = function( Cldr, path, attributes ) {
			// Resolve path
			var normalizedPath = pathNormalize( path, attributes );
	
			return resourceGet( Cldr._resolved, normalizedPath );
		};
	
	
	
	
		/**
		 * new Cldr()
		 */
		var Cldr = function( locale ) {
			this.init( locale );
		};
	
		// Build optimization hack to avoid duplicating functions across modules.
		Cldr._alwaysArray = alwaysArray;
		Cldr._coreLoad = coreLoad;
		Cldr._createError = createError;
		Cldr._itemGetResolved = itemGetResolved;
		Cldr._jsonMerge = jsonMerge;
		Cldr._pathNormalize = pathNormalize;
		Cldr._resourceGet = resourceGet;
		Cldr._validatePresence = validatePresence;
		Cldr._validateType = validateType;
		Cldr._validateTypePath = validateTypePath;
		Cldr._validateTypePlainObject = validateTypePlainObject;
	
		Cldr._availableBundleMap = {};
		Cldr._availableBundleMapQueue = [];
		Cldr._resolved = {};
	
		// Allow user to override locale separator "-" (default) | "_". According to http://www.unicode.org/reports/tr35/#Unicode_language_identifier, both "-" and "_" are valid locale separators (eg. "en_GB", "en-GB"). According to http://unicode.org/cldr/trac/ticket/6786 its usage must be consistent throughout the data set.
		Cldr.localeSep = "-";
	
		/**
		 * Cldr.load( json [, json, ...] )
		 *
		 * @json [JSON] CLDR data or [Array] Array of @json's.
		 *
		 * Load resolved cldr data.
		 */
		Cldr.load = function() {
			Cldr._resolved = coreLoad( Cldr, Cldr._resolved, arguments );
		};
	
		/**
		 * .init() automatically run on instantiation/construction.
		 */
		Cldr.prototype.init = function( locale ) {
			var attributes, language, maxLanguageId, minLanguageId, script, subtags, territory, unicodeLocaleExtensions, variant,
				sep = Cldr.localeSep,
				unicodeLocaleExtensionsRaw = "";
	
			validatePresence( locale, "locale" );
			validateTypeString( locale, "locale" );
	
			subtags = coreSubtags( locale );
	
			if ( subtags.length === 5 ) {
				unicodeLocaleExtensions = subtags.pop();
				unicodeLocaleExtensionsRaw = sep + "u" + sep + unicodeLocaleExtensions;
				// Remove trailing null when there is unicodeLocaleExtensions but no variants.
				if ( !subtags[ 3 ] ) {
					subtags.pop();
				}
			}
			variant = subtags[ 3 ];
	
			// Normalize locale code.
			// Get (or deduce) the "triple subtags": language, territory (also aliased as region), and script subtags.
			// Get the variant subtags (calendar, collation, currency, etc).
			// refs:
			// - http://www.unicode.org/reports/tr35/#Field_Definitions
			// - http://www.unicode.org/reports/tr35/#Language_and_Locale_IDs
			// - http://www.unicode.org/reports/tr35/#Unicode_locale_identifier
	
			// When a locale id does not specify a language, or territory (region), or script, they are obtained by Likely Subtags.
			maxLanguageId = coreLikelySubtags( Cldr, this, subtags, { force: true } ) || subtags;
			language = maxLanguageId[ 0 ];
			script = maxLanguageId[ 1 ];
			territory = maxLanguageId[ 2 ];
	
			minLanguageId = coreRemoveLikelySubtags( Cldr, this, maxLanguageId ).join( sep );
	
			// Set attributes
			this.attributes = attributes = {
				bundle: bundleLookup( Cldr, this, minLanguageId ),
	
				// Unicode Language Id
				minLanguageId: minLanguageId + unicodeLocaleExtensionsRaw,
				maxLanguageId: maxLanguageId.join( sep ) + unicodeLocaleExtensionsRaw,
	
				// Unicode Language Id Subtabs
				language: language,
				script: script,
				territory: territory,
				region: territory, /* alias */
				variant: variant
			};
	
			// Unicode locale extensions.
			unicodeLocaleExtensions && ( "-" + unicodeLocaleExtensions ).replace( /-[a-z]{3,8}|(-[a-z]{2})-([a-z]{3,8})/g, function( attribute, key, type ) {
	
				if ( key ) {
	
					// Extension is in the `keyword` form.
					attributes[ "u" + key ] = type;
				} else {
	
					// Extension is in the `attribute` form.
					attributes[ "u" + attribute ] = true;
				}
			});
	
			this.locale = locale;
		};
	
		/**
		 * .get()
		 */
		Cldr.prototype.get = function( path ) {
	
			validatePresence( path, "path" );
			validateTypePath( path, "path" );
	
			return itemGetResolved( Cldr, path, this.attributes );
		};
	
		/**
		 * .main()
		 */
		Cldr.prototype.main = function( path ) {
			validatePresence( path, "path" );
			validateTypePath( path, "path" );
	
			validate( "E_MISSING_BUNDLE", this.attributes.bundle !== null, {
				locale: this.locale
			});
	
			path = alwaysArray( path );
			return this.get( [ "main/{bundle}" ].concat( path ) );
		};
	
		return Cldr;
	
	
	
	
	}));


/***/ },

/***/ 27:
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(10), src$diff$$ = __webpack_require__(28), src$es5$$ = __webpack_require__(30);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },

/***/ 28:
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },

/***/ 29:
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"Year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"Month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"Day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"Hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"Minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"Second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },

/***/ 30:
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },

/***/ 31:
/***/ function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(27), src$en$$ = __webpack_require__(29);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },

/***/ 33:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedDate = src$react$$["default"].createClass({
	    displayName: 'FormattedDate',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'localeMatcher', 'timeZone', 'hour12', 'formatMatcher', 'weekday',
	            'era', 'year', 'month', 'day', 'hour', 'minute', 'second',
	            'timeZoneName'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('date', format);
	        var options  = FormattedDate.filterFormatOptions(props, defaults);
	
	        return src$react$$["default"].DOM.span(null, this.formatDate(value, options));
	    }
	});
	
	exports["default"] = FormattedDate;
	
	//# sourceMappingURL=date.js.map

/***/ },

/***/ 34:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$escape$$ = __webpack_require__(40), src$mixin$$ = __webpack_require__(4);
	
	var FormattedHTMLMessage = src$react$$["default"].createClass({
	    displayName: 'FormattedHTMLMessage',
	    mixins     : [src$mixin$$["default"]],
	
	    propTypes: {
	        tagName: src$react$$["default"].PropTypes.string,
	        message: src$react$$["default"].PropTypes.string.isRequired
	    },
	
	    getDefaultProps: function () {
	        return {tagName: 'span'};
	    },
	
	    render: function () {
	        var props   = this.props;
	        var tagName = props.tagName;
	        var message = props.message;
	
	        // Process all the props before they are used as values when formatting
	        // the ICU Message string. Since the formatted message will be injected
	        // via `innerHTML`, all String-based values need to be HTML-escaped. Any
	        // React Elements that are passed as props will be rendered to a static
	        // markup string that is presumed to be safe.
	        var values = Object.keys(props).reduce(function (values, name) {
	            var value = props[name];
	
	            if (typeof value === 'string') {
	                value = src$escape$$["default"](value);
	            } else if (src$react$$["default"].isValidElement(value)) {
	                value = src$react$$["default"].renderToStaticMarkup(value);
	            }
	
	            values[name] = value;
	            return values;
	        }, {});
	
	        // Since the message presumably has HTML in it, we need to set
	        // `innerHTML` in order for it to be rendered and not escaped by React.
	        // To be safe, all string prop values were escaped before formatting the
	        // message. It is assumed that the message is not UGC, and came from
	        // the developer making it more like a template.
	        //
	        // Note: There's a perf impact of using this component since there's no
	        // way for React to do its virtual DOM diffing.
	        return src$react$$["default"].DOM[tagName]({
	            dangerouslySetInnerHTML: {
	                __html: this.formatMessage(message, values)
	            }
	        });
	    }
	});
	
	exports["default"] = FormattedHTMLMessage;
	
	//# sourceMappingURL=html-message.js.map

/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedMessage = src$react$$["default"].createClass({
	    displayName: 'FormattedMessage',
	    mixins     : [src$mixin$$["default"]],
	
	    propTypes: {
	        tagName: src$react$$["default"].PropTypes.string,
	        message: src$react$$["default"].PropTypes.string.isRequired
	    },
	
	    getDefaultProps: function () {
	        return {tagName: 'span'};
	    },
	
	    render: function () {
	        var props   = this.props;
	        var tagName = props.tagName;
	        var message = props.message;
	
	        // Creates a token with a random guid that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var guid       = Math.floor(Math.random() * 0x10000000000).toString(16);
	        var tokenRegex = new RegExp('(@__ELEMENT-' + guid + '-\\d+__@)', 'g');
	        var elements   = {};
	
	        var generateToken = (function () {
	            var counter = 0;
	            return function () {
	                return '@__ELEMENT-' + guid + '-' + (counter += 1) + '__@';
	            };
	        }());
	
	        // Iterates over the `props` to keep track of any React Element values
	        // so they can be represented by the `token` as a placeholder when the
	        // `message` is formatted. This allows the formatted message to then be
	        // broken-up into parts with references to the React Elements inserted
	        // back in.
	        var values = Object.keys(props).reduce(function (values, name) {
	            var value = props[name];
	            var token;
	
	            if (src$react$$["default"].isValidElement(value)) {
	                token           = generateToken();
	                values[name]    = token;
	                elements[token] = value;
	            } else {
	                values[name] = value;
	            }
	
	            return values;
	        }, {});
	
	        // Formats the `message` with the `values`, including the `token`
	        // placeholders for React Element values.
	        var formattedMessage = this.formatMessage(message, values);
	
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while keeping
	        // React's virtual diffing working properly.
	        var children = formattedMessage.split(tokenRegex)
	            .filter(function (part) {
	                // Ignore empty string parts.
	                return !!part;
	            })
	            .map(function (part) {
	                // When the `part` is a token, get a ref to the React Element.
	                return elements[part] || part;
	            });
	
	        var elementArgs = [tagName, null].concat(children);
	        return src$react$$["default"].createElement.apply(null, elementArgs);
	    }
	});
	
	exports["default"] = FormattedMessage;
	
	//# sourceMappingURL=message.js.map

/***/ },

/***/ 36:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedNumber = src$react$$["default"].createClass({
	    displayName: 'FormattedNumber',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'localeMatcher', 'style', 'currency', 'currencyDisplay',
	            'useGrouping', 'minimumIntegerDigits', 'minimumFractionDigits',
	            'maximumFractionDigits', 'minimumSignificantDigits',
	            'maximumSignificantDigits'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('number', format);
	        var options  = FormattedNumber.filterFormatOptions(props, defaults);
	
	        return src$react$$["default"].DOM.span(null, this.formatNumber(value, options));
	    }
	});
	
	exports["default"] = FormattedNumber;
	
	//# sourceMappingURL=number.js.map

/***/ },

/***/ 37:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedRelative = src$react$$["default"].createClass({
	    displayName: 'FormattedRelative',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'style', 'units'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired,
	        now   : src$react$$["default"].PropTypes.any
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('relative', format);
	        var options  = FormattedRelative.filterFormatOptions(props, defaults);
	
	        var formattedRelativeTime = this.formatRelative(value, options, {
	            now: props.now
	        });
	
	        return src$react$$["default"].DOM.span(null, formattedRelativeTime);
	    }
	});
	
	exports["default"] = FormattedRelative;
	
	//# sourceMappingURL=relative.js.map

/***/ },

/***/ 38:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext:true */
	
	// TODO: Use `import React from "react";` when external modules are supported.
	"use strict";
	var src$react$$ = __webpack_require__(5), src$mixin$$ = __webpack_require__(4);
	
	var FormattedTime = src$react$$["default"].createClass({
	    displayName: 'FormattedTime',
	    mixins     : [src$mixin$$["default"]],
	
	    statics: {
	        formatOptions: [
	            'localeMatcher', 'timeZone', 'hour12', 'formatMatcher', 'weekday',
	            'era', 'year', 'month', 'day', 'hour', 'minute', 'second',
	            'timeZoneName'
	        ]
	    },
	
	    propTypes: {
	        format: src$react$$["default"].PropTypes.string,
	        value : src$react$$["default"].PropTypes.any.isRequired
	    },
	
	    render: function () {
	        var props    = this.props;
	        var value    = props.value;
	        var format   = props.format;
	        var defaults = format && this.getNamedFormat('time', format);
	        var options  = FormattedTime.filterFormatOptions(props, defaults);
	
	        return src$react$$["default"].DOM.span(null, this.formatTime(value, options));
	    }
	});
	
	exports["default"] = FormattedTime;
	
	//# sourceMappingURL=time.js.map

/***/ },

/***/ 39:
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"Year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"Month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"Day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"Hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"Minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"Second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },

/***/ 40:
/***/ function(module, exports) {

	/* jshint esnext:true */
	
	/*
	HTML escaping implementation is the same as React's (on purpose.) Therefore, it
	has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	"use strict";
	var ESCAPED_CHARS = {
	    '&' : '&amp;',
	    '>' : '&gt;',
	    '<' : '&lt;',
	    '"' : '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	exports["default"] = function (str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	};
	
	//# sourceMappingURL=escape.js.map

/***/ },

/***/ 41:
/***/ function(module, exports, __webpack_require__) {

	/* jshint esnext: true */
	
	"use strict";
	exports.__addLocaleData = __addLocaleData;
	var intl$messageformat$$ = __webpack_require__(10), intl$relativeformat$$ = __webpack_require__(11), src$en$$ = __webpack_require__(39), src$mixin$$ = __webpack_require__(4), src$components$date$$ = __webpack_require__(33), src$components$time$$ = __webpack_require__(38), src$components$relative$$ = __webpack_require__(37), src$components$number$$ = __webpack_require__(36), src$components$message$$ = __webpack_require__(35), src$components$html$message$$ = __webpack_require__(34);
	function __addLocaleData(data) {
	    intl$messageformat$$["default"].__addLocaleData(data);
	    intl$relativeformat$$["default"].__addLocaleData(data);
	}
	
	__addLocaleData(src$en$$["default"]);
	exports.IntlMixin = src$mixin$$["default"], exports.FormattedDate = src$components$date$$["default"], exports.FormattedTime = src$components$time$$["default"], exports.FormattedRelative = src$components$relative$$["default"], exports.FormattedNumber = src$components$number$$["default"], exports.FormattedMessage = src$components$message$$["default"], exports.FormattedHTMLMessage = src$components$html$message$$["default"];
	
	//# sourceMappingURL=react-intl.js.map

/***/ },

/***/ 42:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(44)['default'];
	exports['default'] = exports;


/***/ },

/***/ 43:
/***/ function(module, exports) {

	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },

/***/ 44:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var src$es5$$ = __webpack_require__(43);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = src$es5$$.objCreate(FormatConstructor.prototype);
	            FormatConstructor.apply(format, args);
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ },

/***/ 45:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 46:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 55:
/***/ function(module, exports) {

	'use strict';
	
	var ADDRESS_VALIDATION_ERROR = {
	    PO_BOX_UNSUPPORTED: 'address_validation.invalid_po_box',
	    ADDRESS_REGION_NOT_SUPPORTED: 'address_validation.invalid_territory_unsupported',
	    INVALID: 'address_validation.invalid_error',
	    SERVICE_ERROR: 'address_validation.service_error'
	};
	
	function addressValidationErrorContentKey(error) {
	    if (!error) {
	        return '';
	    }
	
	    var contentKey = ADDRESS_VALIDATION_ERROR[error];
	    if (!contentKey) {
	        console.warn('Error content not found:' + contentKey);
	        contentKey = ADDRESS_VALIDATION_ERROR.INVALID;
	    }
	
	    return contentKey;
	}
	
	/**
	 * Defines formats for interpolation variables that are localised by griffin instead of by the L10N team.
	 *
	 * Currencies:
	 * {$0}=0
	 * {$0.00}=$0.00
	 * {$3c95}=$3.95
	 *
	 * Percentages:
	 * {%5}=5%
	 * {%2pt5}=2.5%
	 */
	function griffinKeyCreator(griffinNumberHandler) {
	    var griffinNumber = griffinNumberHandler;
	
	    /**
	     * @param obj Object to insert property into. This is usually the interpolation object passed as i18n()'s second param.
	     * @param pcValue {Number|String}
	     */
	    function insertLocalisedPercentageProperty(obj, pcValue) {
	        var wholeNumber = parseInt(pcValue);
	        var decimalValue = pcValue % 1;
	
	        var decimalPart = decimalValue ? String(decimalValue).replace('0.', 'pt') : '';
	        obj['%' + wholeNumber + decimalPart] = getLocalisedPercentage(pcValue);
	        return obj;
	    }
	
	    function getLocalisedPercentage(value) {
	        return griffinNumber.formatNumber(value / 100, { style: 'percent' });
	    }
	
	    /**
	     * cents is optional
	     */
	    function insertLocalisedCurrencyProperty(obj, amtString) {
	        var splits = amtString.split('.');
	        var dollars = splits[0];
	        var cents = splits[1];
	        var noCents = cents === undefined;
	
	        obj['$' + dollars + (cents ? 'c' + cents : '')] = getLocalisedCurrency(dollars, cents, noCents);
	        return obj;
	    }
	
	    /**
	     * cents is optional
	     */
	    function getLocalisedCurrency(dollars, cents, noCents) {
	        var currencyFormat = griffinNumber.CURRENCY_FORMAT;
	        if (noCents) {
	            currencyFormat.maximumFractionDigits = 0;
	        }
	        return griffinNumber.formatCurrency({
	            value: Number(dollars) + (cents ? cents / 100 : 0),
	            currency: 'USD'
	        }, currencyFormat);
	    }
	
	    return {
	        insertLocalisedPercentageProperty: insertLocalisedPercentageProperty,
	        insertLocalisedCurrencyProperty: insertLocalisedCurrencyProperty
	    };
	}
	
	module.exports = {
	    addressValidationErrorContentKey: addressValidationErrorContentKey,
	    griffinKeyCreator: griffinKeyCreator
	};

/***/ },

/***/ 56:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * CLDR JavaScript Library v0.5.4
	 * http://jquery.com/
	 *
	 * Copyright 2013 Rafael Xavier de Souza
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2020-10-22T15:56Z
	 */
	/*!
	 * CLDR JavaScript Library v0.5.4 2020-10-22T15:56Z MIT license © Rafael Xavier
	 * http://git.io/h4lmVg
	 */
	
	// Cldr
	module.exports = __webpack_require__( 23 );
	
	// Extent Cldr with the following modules
	__webpack_require__( 118 );
	__webpack_require__( 119 );
	__webpack_require__( 120 );


/***/ },

/***/ 57:
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Basic utilities module.
	 * @module utils/basic
	 */
	
	/* Gets value in object path
	 * @param {object} obj
	 * @param {string|array} path
	 * @examples
	 * get({foo: 1, bar: {baz: 2}}, 'bar/baz');
	 * > 2
	 * get({foo: 1, bar: {baz: 2}}, 'foo/bar/baz/quax');
	 * > undefined
	 */
	function objectGet(obj, path) {
	  if (typeof path === "string") {
	    path = path.split("/");
	  }
	  var prop = path.slice(-1);
	  var node = path.slice(0, -1).reduce(function(node, item) {
	    return node[item] || {};
	  }, obj);
	  return node[prop];
	}
	
	/**
	 * Sets value in object path
	 * @param {object} obj
	 * @param {string|array} path
	 * @param {*} value
	 * @examples
	 * set({foo: 1}, 'bar/baz', 2);
	 * // > {foo: 1, bar: {baz: 2}}
	 */
	function objectSet(obj, path, value) {
	  if (typeof path === "string") {
	    path = path.split("/");
	  }
	  var prop = path.slice(-1);
	  var node = path.slice(0, -1).reduce(function(node, item) {
	    return (node[item] = node[item] || {});
	  }, obj);
	  node[prop] = value;
	  return obj;
	}
	
	/**
	 * Given an object, return an array of its property values.
	 * @param {Object} object
	 */
	function objectValues(object) {
	  return Object.keys(object).map(function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Slices an object given a path.
	 */
	function objectSlice(obj, path) {
	  path = path || [];
	  return objectSet({}, path, objectGet(obj, path));
	}
	
	function cloneArray(array) {
	  return array.slice(0);
	}
	
	function cloneDate(date) {
	  return new Date(date.getTime());
	}
	
	/**
	 * Returns new deeply merged JSON-parsed objects.
	 * @param {...object} obj - Object to perform deep merge
	 * @returns {object} Deeply merged object. This returned object can be safely modified without
	 * causing any change on any passed source objects.
	 *
	 * @example
	 * merge( { a: { b: 1, c: 2 } }, { a: { b: 3, d: 4 } }, ... )
	 * // > { a: { b: 3, c: 2, d: 4 } }
	 *
	 * Code from https://github.com/rxaviers/cldrjs/blob/master/src/util/json/merge.js
	 */
	function jsonDeepMerge(/* obj */) {
	  var destination = {};
	  var sources = [].slice.call(arguments, 0);
	  sources.forEach(function(source) {
	    var prop;
	    for (prop in source) {
	      if (Array.isArray(source[prop])) {
	        // Clone and set arrays.
	        destination[prop] = cloneArray(source[prop]);
	      } else if (source[prop] instanceof Date) {
	        // Clone and set dates.
	        destination[prop] = cloneDate(source[prop]);
	      } else if (typeof source[prop] === "object") {
	        // Merge objects.
	        destination[prop] = jsonDeepMerge({}, destination[prop], source[prop]);
	      } else {
	        // Set new values.
	        destination[prop] = source[prop];
	      }
	    }
	  });
	  return destination;
	}
	
	/**
	 * Oneliner for Object.defineProperty() using simple `value` descriptor.
	 * @param {Object} object The object on which to define the property.
	 * @param {string} property The name of the property to be defined or modified.
	 * @param {*} value The value associated with the property. Can be any valid JavaScript value (number, object, function, etc).
	 */
	function definePrivateProperty(object, property, value) {
	  Object.defineProperty(object, property, {
	    value: value
	  });
	}
	
	/**
	 * TODO description.
	 */
	function defineProperties(handler, properties) {
	  var propertiesNames = Object.keys(properties);
	  propertiesNames.forEach(function(key) {
	    Object.defineProperty(handler.prototype, key, {
	      get: function() {
	        return properties[key];
	      },
	      enumerable: true
	    });
	  });
	
	  return objectValues(properties);
	}
	
	/**
	 * Formats a message replacing placeholders with variables values.
	 * @param {string} message - A message that can contain placeholders.
	 * @param {Object} [variables] - Variables for replacing message placeholders.
	 *
	 * @example
	 * formatMessage("Hello {name}", {name: "John"});
	 * // > "Hello John"
	 *
	 * formatMessage("Hello {{name}}", {name: "John"});
	 * // > "Hello \"John\""
	 */
	function formatMessage(message, variables) {
	  return (
	    message
	      // Replace {{variable}} with `JSON.stringify(variableValue)`.
	      .replace(/{{([0-9a-zA-Z-_. ]+)}}/g, function(_, variable) {
	        // JSON.stringify(NaN) yields 'null', so we need a special case for NaN
	        if (
	          typeof variables[variable] === "number" &&
	          isNaN(variables[variable])
	        ) {
	          return "NaN";
	        }
	        return JSON.stringify(variables[variable]);
	      })
	      // Replace {variable} with `variableValue`.
	      .replace(/{([0-9a-zA-Z-_. ]+)}/g, function(_, variable) {
	        return variables[variable];
	      })
	  );
	}
	
	/**
	 * Checks if passed *object* is a plain object.
	 * @param {*} object - Value subject to test.
	 * @returns {boolean} Returns `true` if *object* is a plain object or `false`.
	 *
	 * @example
	 *
	 * isPlainObject(); // > false
	 * isPlainObject(null); // > false
	 * isPlainObject(new Date()); // > false
	 * isPlainObject([]); // > false
	 * isPlainObject(1); // > false
	 * isPlainObject(true); // > false
	 * isPlainObject("foo"); // > false
	 * isPlainObject(function() {}); // > false
	 * isPlainObject({a: 1}); // > true
	 */
	function isPlainObject(object) {
	  // Inspired by jQuery Core, but reduced to our use case.
	  return (
	    object !== null &&
	    "" + object === "[object Object]" &&
	    object.constructor === Object
	  );
	}
	
	/**
	 * @param {Array} array - The list of strings to glue together as an English formatted list string.
	 * @param {string} conjunction - Conjunction value, e.g., `'and'`, `'or'`.
	 * @returns {string} Returns an English formatted list string using the passed *conjunction*.
	 *
	 * @example
	 *
	 * listFormat([], 'or'); // > ''
	 * listFormat(['foo'], 'or'); // > 'foo'
	 * listFormat(['foo', 'bar'], 'or'); // > 'foo or bar'
	 * listFormat(['foo', 'bar', 'baz'], 'or'); // > 'foo, or bar, or baz'
	 */
	function listFormat(array, conjunction) {
	  if (array.length === 0) {
	    return "";
	  }
	  if (array.length === 1) {
	    return array[0];
	  }
	  if (array.length === 2) {
	    return array.join(" " + conjunction + " ");
	  }
	  if (array.length > 2) {
	    return array.join(", " + conjunction + " ");
	  }
	}
	
	/**
	 * Returns the type of a variable with additional types than native `typeof`.
	 * @param {*} variable - A variable to deduce its type.
	 *
	 * @example
	 * smarterTypeof(null); // > "null"
	 * smarterTypeof({a: 1}); // > "plain object"
	 * smarterTypeof([]); // > "array"
	 * smarterTypeof(new Date()); // > "date"
	 * smarterTypeof(<anything else>); // > result of regular typeof.
	 */
	function smarterTypeof(variable) {
	  if (variable === null) {
	    return "null";
	  }
	  if (isPlainObject(variable)) {
	    return "plain object";
	  }
	  if (Array.isArray(variable)) {
	    return "array";
	  }
	  if (variable instanceof Date) {
	    return "date";
	  }
	  return typeof variable;
	}
	
	/**
	 * Returns `true` is *element* belongs to *collection*.
	 * @param {*} element - The key of an Object or the element of an Array.
	 * @param {(Array| Object)} Where to search for element at.
	 *
	 * @example
	 *
	 * withinRange("bar", ["foo", "bar", "baz"]);
	 * // > true
	 * withinRange("quax", ["foo", "bar", "baz"]);
	 * // > false
	 *
	 * @example
	 *
	 * withinRange("bar", {foo: 1, bar: 2, baz: 3});
	 * // > true
	 * withinRange("quax", {foo: 1, bar: 2, baz: 3});
	 * // > false
	 */
	function withinRange(element, collection) {
	  return Array.isArray(collection)
	    ? collection.indexOf(element) !== -1
	    : element in collection;
	}
	
	/**
	 * Given a value and a default for that value,
	 * if value is undefined, return the default.
	 * Otherwise, return the value itself.
	 * @param {*} value the value which may or may not be undefined
	 * @param {*} defaultValue the default for value
	 *
	 * @example
	 *
	 * getValueOrDefault('my string', 'default string');
	 * // > 'my string'
	 * getValueOrDefault(undefined, 'default string');
	 * // > 'default string'
	 */
	function getValueOrDefault(value, defaultValue) {
	  return value === undefined ? defaultValue : value;
	}
	
	/**
	 * Given an object with properties and an array of valid string property names,
	 * Clone the object and:
	 * 1) Remove invalid properties,
	 * 2) Remove non-string properties,
	 * 3) Remove properties with only whitespace,
	 * 4) Trim remaining string properties
	 *
	 * @param {Object} object the object to trim
	 * @param {array} properties array of properties to preserve
	 *
	 * @return {Object} the cloned & trimmed object
	 */
	function trimObject(object, properties) {
	  var clonedObject = {};
	  properties.forEach(function(property) {
	    var value = object[property];
	    if (value === undefined) {
	      return;
	    }
	    if (typeof value === "string") {
	      value = value.trim();
	    }
	    clonedObject[property] = value;
	  });
	  return clonedObject;
	}
	
	/**
	 * Given a string, return true if all the characters are Latin script (roughly < U+024F)
	 * Note that empty strings are Latin by definition
	 * @param {string} string to test
	 * @return {boolean}
	 */
	function isLatin(string) {
	  if (!string) {
	    return true;
	  }
	  for (var i = 0; i < string.length; i++) {
	    if (
	      string.charCodeAt(i) > 0x24f &&
	      (string.charCodeAt(i) < 0x2000 || string.charCodeAt(i) > 0x206f)
	    ) {
	      return false;
	    }
	  }
	  return true;
	}
	/**
	 * This version might be used in for loops and the like when
	 * it is unknown whether non-BMP characters exist before the specified index position.
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
	 * @param {string} string to get the character
	 * @peram {number} the index position
	 **/
	function fixedCharCodeAt(str, idx) {
	  // ex. fixedCharCodeAt('\uD800\uDC00', 0); // 65536
	  // ex. fixedCharCodeAt('\uD800\uDC00', 1); // false
	  idx = idx || 0;
	  var code = str.charCodeAt(idx);
	  var hi, low;
	
	  // High surrogate (could change last hex to 0xDB7F
	  // to treat high private surrogates
	  // as single characters)
	  if (0xd800 <= code && code <= 0xdbff) {
	    hi = code;
	    low = str.charCodeAt(idx + 1);
	    if (isNaN(low)) {
	      return hi;
	    }
	    return (hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
	  }
	  if (0xdc00 <= code && code <= 0xdfff) {
	    // Low surrogate
	    // We return false to allow loops to skip
	    // this iteration since should have already handled
	    // high surrogate above in the previous iteration
	    return false;
	    // hi = str.charCodeAt(idx - 1);
	    // low = code;
	    // return ((hi - 0xD800) * 0x400) +
	    //   (low - 0xDC00) + 0x10000;
	  }
	  return code;
	}
	
	function invalidCodePointFromString(string, regex) {
	  var codePoint;
	  for (var i = 0, chr; i < string.length; i++) {
	    if (string[i].match(regex) === null) {
	      if ((chr = fixedCharCodeAt(string, i)) === false) {
	        continue;
	      }
	      codePoint = chr;
	      /* we care only on the first one */
	      break;
	    }
	  }
	
	  return codePoint;
	}
	
	module.exports = {
	  objectGet: objectGet,
	  objectSet: objectSet,
	  objectValues: objectValues,
	  objectSlice: objectSlice,
	  jsonDeepMerge: jsonDeepMerge,
	  isLatin: isLatin,
	  trimObject: trimObject,
	  definePrivateProperty: definePrivateProperty,
	  defineProperties: defineProperties,
	  formatMessage: formatMessage,
	  getValueOrDefault: getValueOrDefault,
	  isPlainObject: isPlainObject,
	  listFormat: listFormat,
	  smarterTypeof: smarterTypeof,
	  withinRange: withinRange,
	  fixedCharCodeAt: fixedCharCodeAt,
	  invalidCodePointFromString: invalidCodePointFromString
	};


/***/ },

/***/ 58:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Globalize v1.6.0
	 *
	 * http://github.com/jquery/globalize
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2020-09-08T11:54Z
	 */
	/*!
	 * Globalize v1.6.0 2020-09-08T11:54Z Released under the MIT license
	 * http://git.io/TrdQbw
	 */
	(function( root, factory ) {
	
		// UMD returnExports
		if ( false ) {
	
			// AMD
			define([
				"cldr",
				"cldr/event"
			], factory );
		} else if ( true ) {
	
			// Node, CommonJS
			module.exports = factory( __webpack_require__( 56 ) );
		} else {
	
			// Global
			root.Globalize = factory( root.Cldr );
		}
	}( this, function( Cldr ) {
	
	
	/**
	 * A toString method that outputs meaningful values for objects or arrays and
	 * still performs as fast as a plain string in case variable is string, or as
	 * fast as `"" + number` in case variable is a number.
	 * Ref: http://jsperf.com/my-stringify
	 */
	var toString = function( variable ) {
		return typeof variable === "string" ? variable : ( typeof variable === "number" ? "" +
			variable : JSON.stringify( variable ) );
	};
	
	
	
	
	/**
	 * formatMessage( message, data )
	 *
	 * @message [String] A message with optional {vars} to be replaced.
	 *
	 * @data [Array or JSON] Object with replacing-variables content.
	 *
	 * Return the formatted message. For example:
	 *
	 * - formatMessage( "{0} second", [ 1 ] ); // 1 second
	 *
	 * - formatMessage( "{0}/{1}", ["m", "s"] ); // m/s
	 *
	 * - formatMessage( "{name} <{email}>", {
	 *     name: "Foo",
	 *     email: "bar@baz.qux"
	 *   }); // Foo <bar@baz.qux>
	 */
	var formatMessage = function( message, data ) {
	
		// Replace {attribute}'s
		message = message.replace( /{[0-9a-zA-Z-_. ]+}/g, function( name ) {
			name = name.replace( /^{([^}]*)}$/, "$1" );
			return toString( data[ name ] );
		});
	
		return message;
	};
	
	
	
	
	var objectExtend = function() {
		var destination = arguments[ 0 ],
			sources = [].slice.call( arguments, 1 );
	
		sources.forEach(function( source ) {
			var prop;
			for ( prop in source ) {
				destination[ prop ] = source[ prop ];
			}
		});
	
		return destination;
	};
	
	
	
	
	var createError = function( code, message, attributes ) {
		var error;
	
		message = code + ( message ? ": " + formatMessage( message, attributes ) : "" );
		error = new Error( message );
		error.code = code;
	
		objectExtend( error, attributes );
	
		return error;
	};
	
	
	
	
	/**
	 * Pushes part to parts array, concat two consecutive parts of the same type.
	 */
	var partsPush = function( parts, type, value ) {
	
			// Concat two consecutive parts of same type
			if ( parts.length && parts[ parts.length - 1 ].type === type ) {
				parts[ parts.length - 1 ].value += value;
				return;
			}
	
			parts.push( { type: type, value: value } );
	};
	
	
	
	
	/**
	 * formatMessage( message, data )
	 *
	 * @message [String] A message with optional {vars} to be replaced.
	 *
	 * @data [Array or JSON] Object with replacing-variables content.
	 *
	 * Return the formatted message. For example:
	 *
	 * - formatMessage( "{0} second", [ 1 ] );
	 * > [{type: "variable", value: "1", name: "0"}, {type: "literal", value: " second"}]
	 *
	 * - formatMessage( "{0}/{1}", ["m", "s"] );
	 * > [
	 *     { type: "variable", value: "m", name: "0" },
	 *     { type: "literal", value: " /" },
	 *     { type: "variable", value: "s", name: "1" }
	 *   ]
	 */
	var formatMessageToParts = function( message, data ) {
	
		var lastOffset = 0,
			parts = [];
	
		// Create parts.
		message.replace( /{[0-9a-zA-Z-_. ]+}/g, function( nameIncludingBrackets, offset ) {
			var name = nameIncludingBrackets.slice( 1, -1 );
			partsPush( parts, "literal", message.slice( lastOffset, offset ));
			partsPush( parts, "variable", data[ name ] );
			parts[ parts.length - 1 ].name = name;
			lastOffset += offset + nameIncludingBrackets.length;
		});
	
		// Skip empty ones such as `{ type: 'literal', value: '' }`.
		return parts.filter(function( part ) {
			return part.value !== "";
		});
	};
	
	
	
	
	/**
	 * Returns joined parts values.
	 */
	var partsJoin = function( parts ) {
		return parts.map( function( part ) {
			return part.value;
		}).join( "" );
	};
	
	
	
	
	var runtimeStringify = function( args ) {
		return JSON.stringify( args, function( key, value ) {
			if ( value && value.runtimeKey ) {
				return value.runtimeKey;
			}
			return value;
		} );
	};
	
	
	
	
	// Based on http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
	var stringHash = function( str ) {
		return [].reduce.call( str, function( hash, i ) {
			var chr = i.charCodeAt( 0 );
			hash = ( ( hash << 5 ) - hash ) + chr;
			return hash | 0;
		}, 0 );
	};
	
	
	
	
	var runtimeKey = function( fnName, locale, args, argsStr ) {
		var hash;
		argsStr = argsStr || runtimeStringify( args );
		hash = stringHash( fnName + locale + argsStr );
		return hash > 0 ? "a" + hash : "b" + Math.abs( hash );
	};
	
	
	
	
	var functionName = function( fn ) {
		if ( fn.name !== undefined ) {
			return fn.name;
		}
	
		// fn.name is not supported by IE.
		var matches = /^function\s+([\w\$]+)\s*\(/.exec( fn.toString() );
	
		if ( matches && matches.length > 0 ) {
			return matches[ 1 ];
		}
	};
	
	
	
	
	var runtimeBind = function( args, cldr, fn, runtimeArgs ) {
	
		var argsStr = runtimeStringify( args ),
			fnName = functionName( fn ),
			locale = cldr.locale;
	
		// If name of the function is not available, this is most likely due to uglification,
		// which most likely means we are in production, and runtimeBind here is not necessary.
		if ( !fnName ) {
			return fn;
		}
	
		fn.runtimeKey = runtimeKey( fnName, locale, null, argsStr );
	
		fn.generatorString = function() {
			return "Globalize(\"" + locale + "\")." + fnName + "(" + argsStr.slice( 1, -1 ) + ")";
		};
	
		fn.runtimeArgs = runtimeArgs;
	
		return fn;
	};
	
	
	
	
	var validate = function( code, message, check, attributes ) {
		if ( !check ) {
			throw createError( code, message, attributes );
		}
	};
	
	
	
	
	var alwaysArray = function( stringOrArray ) {
		return Array.isArray( stringOrArray ) ? stringOrArray : stringOrArray ? [ stringOrArray ] : [];
	};
	
	
	
	
	var validateCldr = function( path, value, options ) {
		var skipBoolean;
		options = options || {};
	
		skipBoolean = alwaysArray( options.skip ).some(function( pathRe ) {
			return pathRe.test( path );
		});
	
		validate( "E_MISSING_CLDR", "Missing required CLDR content `{path}`.", value || skipBoolean, {
			path: path
		});
	};
	
	
	
	
	var validateDefaultLocale = function( value ) {
		validate( "E_DEFAULT_LOCALE_NOT_DEFINED", "Default locale has not been defined.",
			value !== undefined, {} );
	};
	
	
	
	
	var validateParameterPresence = function( value, name ) {
		validate( "E_MISSING_PARAMETER", "Missing required parameter `{name}`.",
			value !== undefined, { name: name });
	};
	
	
	
	
	/**
	 * range( value, name, minimum, maximum )
	 *
	 * @value [Number].
	 *
	 * @name [String] name of variable.
	 *
	 * @minimum [Number]. The lowest valid value, inclusive.
	 *
	 * @maximum [Number]. The greatest valid value, inclusive.
	 */
	var validateParameterRange = function( value, name, minimum, maximum ) {
		validate(
			"E_PAR_OUT_OF_RANGE",
			"Parameter `{name}` has value `{value}` out of range [{minimum}, {maximum}].",
			value === undefined || value >= minimum && value <= maximum,
			{
				maximum: maximum,
				minimum: minimum,
				name: name,
				value: value
			}
		);
	};
	
	
	
	
	var validateParameterType = function( value, name, check, expected ) {
		validate(
			"E_INVALID_PAR_TYPE",
			"Invalid `{name}` parameter ({value}). {expected} expected.",
			check,
			{
				expected: expected,
				name: name,
				value: value
			}
		);
	};
	
	
	
	
	var validateParameterTypeLocale = function( value, name ) {
		validateParameterType(
			value,
			name,
			value === undefined || typeof value === "string" || value instanceof Cldr,
			"String or Cldr instance"
		);
	};
	
	
	
	
	/**
	 * Function inspired by jQuery Core, but reduced to our use case.
	 */
	var isPlainObject = function( obj ) {
		return obj !== null && "" + obj === "[object Object]";
	};
	
	
	
	
	var validateParameterTypePlainObject = function( value, name ) {
		validateParameterType(
			value,
			name,
			value === undefined || isPlainObject( value ),
			"Plain Object"
		);
	};
	
	
	
	
	var alwaysCldr = function( localeOrCldr ) {
		return localeOrCldr instanceof Cldr ? localeOrCldr : new Cldr( localeOrCldr );
	};
	
	
	
	
	// ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions?redirectlocale=en-US&redirectslug=JavaScript%2FGuide%2FRegular_Expressions
	var regexpEscape = function( string ) {
		return string.replace( /([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1" );
	};
	
	
	
	
	var stringPad = function( str, count, right ) {
		var length;
		if ( typeof str !== "string" ) {
			str = String( str );
		}
		for ( length = str.length; length < count; length += 1 ) {
			str = ( right ? ( str + "0" ) : ( "0" + str ) );
		}
		return str;
	};
	
	
	
	
	function validateLikelySubtags( cldr ) {
		cldr.once( "get", validateCldr );
		cldr.get( "supplemental/likelySubtags" );
	}
	
	/**
	 * [new] Globalize( locale|cldr )
	 *
	 * @locale [String]
	 *
	 * @cldr [Cldr instance]
	 *
	 * Create a Globalize instance.
	 */
	function Globalize( locale ) {
		if ( !( this instanceof Globalize ) ) {
			return new Globalize( locale );
		}
	
		validateParameterPresence( locale, "locale" );
		validateParameterTypeLocale( locale, "locale" );
	
		this.cldr = alwaysCldr( locale );
	
		validateLikelySubtags( this.cldr );
	}
	
	/**
	 * Globalize.load( json, ... )
	 *
	 * @json [JSON]
	 *
	 * Load resolved or unresolved cldr data.
	 * Somewhat equivalent to previous Globalize.addCultureInfo(...).
	 */
	Globalize.load = function() {
	
		// validations are delegated to Cldr.load().
		Cldr.load.apply( Cldr, arguments );
	};
	
	/**
	 * Globalize.locale( [locale|cldr] )
	 *
	 * @locale [String]
	 *
	 * @cldr [Cldr instance]
	 *
	 * Set default Cldr instance if locale or cldr argument is passed.
	 *
	 * Return the default Cldr instance.
	 */
	Globalize.locale = function( locale ) {
		validateParameterTypeLocale( locale, "locale" );
	
		if ( arguments.length ) {
			this.cldr = alwaysCldr( locale );
			validateLikelySubtags( this.cldr );
		}
		return this.cldr;
	};
	
	/**
	 * Optimization to avoid duplicating some internal functions across modules.
	 */
	Globalize._alwaysArray = alwaysArray;
	Globalize._createError = createError;
	Globalize._formatMessage = formatMessage;
	Globalize._formatMessageToParts = formatMessageToParts;
	Globalize._isPlainObject = isPlainObject;
	Globalize._objectExtend = objectExtend;
	Globalize._partsJoin = partsJoin;
	Globalize._partsPush = partsPush;
	Globalize._regexpEscape = regexpEscape;
	Globalize._runtimeBind = runtimeBind;
	Globalize._stringPad = stringPad;
	Globalize._validate = validate;
	Globalize._validateCldr = validateCldr;
	Globalize._validateDefaultLocale = validateDefaultLocale;
	Globalize._validateParameterPresence = validateParameterPresence;
	Globalize._validateParameterRange = validateParameterRange;
	Globalize._validateParameterTypePlainObject = validateParameterTypePlainObject;
	Globalize._validateParameterType = validateParameterType;
	
	return Globalize;
	
	
	
	
	}));


/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Assertion utilities module.
	 * @module utils/assertion
	 *
	 * @example
	 *
	 * function myFunction(foo, bar) {
	 *   assertType(foo, 'foo', ['string']);
	 *   assertType(bar, 'bar', ['plain object']);
	 * }
	 *
	 * myFunction(1);
	 * // > TypeError: Parameter `foo` must be a string, not number `1`
	 *
	 * myFunction("1", []);
	 * // > TypeError: Parameter `bar` must be a plain object, not array `[]`
	 */
	"use strict";
	
	var basic = __webpack_require__(57);
	var objectAssign = __webpack_require__(61);
	
	var formatMessage = basic.formatMessage;
	var listFormat = basic.listFormat;
	var smarterTypeof = basic.smarterTypeof;
	var withinRange = basic.withinRange;
	
	/**
	 * Asserts values that are assumed to be true.
	 * @param {boolean} condition - Won't throw if true, will throw if false.
	 * @param {string} errorMessage - The error message. Can contain placeholders for variable
	 *        replacement, e.g., 'Hello {name}' where the value for name comes from `options.name`.
	 * @param {Object} [options]
	 * @param {Object} [options.errorClass=Error] The class of the error to throw.
	 * @param {string} [options.*] Any other option will be used for variable replacement in
	 *        errorMessage.
	 * @returns Returns `true` if *condition* if `true`.
	 * @throws Will throw *option.errorClass* if *condition* if `false`.
	 *
	 * @example
	 *
	 * // This will not throw and return true.
	 * assert(truthyValue, 'error message');
	 * // > true
	 *
	 * @example
	 *
	 * // This will throw an error with this error message.
	 * assert(falseyValue, 'error message');
	 * // > throw Error('error message')
	 */
	function assert(condition, errorMessage, options) {
	  var error, errorClass;
	
	  if (condition) {
	    return true;
	  }
	
	  options = options || {};
	  // Assign errorClass and remove it from options.
	  errorClass = options.errorClass || Error;
	
	  errorMessage = formatMessage(errorMessage, options);
	  error = new errorClass(errorMessage);
	  error.attributes = options;
	
	  throw error;
	}
	
	/**
	 * TODO description.
	 */
	function assertMetadata(metadataNode, expectedTypes) {
	  expectedTypes = expectedTypes || ["plain object"];
	  assertType(metadataNode, "", expectedTypes, {
	    errorMessage: "The metadata is invalid"
	  });
	}
	
	/**
	 * Throw a TypeError in case *parameterValue* isn't any of *expectedTypes*.
	 *
	 * @param {*} parameterValue - Used in the error message as *parameterValue* and the deduced *parameterType* variables.
	 * @param {string} parameterName - Used in the error message as *parameterName* variable.
	 * @param {Array} expectedTypes - A list of expected (smart) typeofs.
	 * @param {Object} [options]
	 * @param {boolean} [options.condition] An optional condition that overrides the default logic, in which case *expectedTypes* values are completely ignored.
	 * @param {String} [options.errorMessage] An optional error message that overrides the default one. Note the error message can use the following automatically set variables: parameterName, parameterValue, parameterType.
	 *
	 * @example
	 *
	 * myParam = "foo";
	 * assertType(
	 *   myParam,
	 *   'myParam',
	 *   ["number"]
	 * );
	 * // > TypeError: Parameter `myParam` must be a number, not string `"foo"`
	 *
	 * myParam = [];
	 * assertType(
	 *   myParam,
	 *   'myParam',
	 *   ["number", "string"]
	 * );
	 * // > TypeError: Parameter `myParam` must be a number or string, not array `[]`
	 */
	function assertType(parameterValue, parameterName, expectedTypes, options) {
	  var parameterType = smarterTypeof(parameterValue);
	
	  options = options || {};
	  var condition =
	    options.condition || expectedTypes.indexOf(parameterType) !== -1;
	  var errorMessage =
	    options.errorMessage ||
	    "Parameter `{parameterName}` must be a {expectedTypesMessage}, not {parameterType} `{{parameterValue}}`";
	
	  assert(condition, errorMessage, {
	    errorClass: TypeError,
	    expectedTypesMessage: listFormat(expectedTypes, "or"),
	    parameterName: parameterName,
	    parameterType: parameterType,
	    parameterValue: parameterValue
	  });
	}
	
	/**
	 * Throw a RangeError in case *element* isn't included in the *collection*.
	 *
	 * @param {*} element - The key of an Object or the element of an Array.
	 * @param {(Array|Object)} collection - Where to search for element at.
	 * @param {string} errorMessage - See assert().
	 * @param {Object} [options] - See assert().
	 *
	 * @example
	 * assertRange("quax", ["foo", "bar", "baz"], "Invalid element");
	 * // > RangeError: Invalid element
	 *
	 * assertRange("quax", {"foo": 1, "bar": 2, "baz": 3}, "Invalid key");
	 * // > RangeError: Invalid key
	 */
	function assertRange(element, collection, errorMessage, options) {
	  assert(
	    withinRange(element, collection),
	    errorMessage,
	    objectAssign({ errorClass: RangeError }, options)
	  );
	}
	
	module.exports = {
	  assert: assert,
	  assertMetadata: assertMetadata,
	  assertRange: assertRange,
	  assertType: assertType
	};


/***/ },

/***/ 61:
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },

/***/ 118:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * CLDR JavaScript Library v0.5.4
	 * http://jquery.com/
	 *
	 * Copyright 2013 Rafael Xavier de Souza
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2020-10-22T15:56Z
	 */
	/*!
	 * CLDR JavaScript Library v0.5.4 2020-10-22T15:56Z MIT license © Rafael Xavier
	 * http://git.io/h4lmVg
	 */
	(function( factory ) {
	
		if ( true ) {
			// AMD.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(23) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ( typeof module === "object" && typeof module.exports === "object" ) {
			// Node. CommonJS.
			module.exports = factory( require( "../cldr" ) );
		} else {
			// Global
			factory( Cldr );
		}
	
	}(function( Cldr ) {
	
		// Build optimization hack to avoid duplicating functions across modules.
		var pathNormalize = Cldr._pathNormalize,
			validatePresence = Cldr._validatePresence,
			validateType = Cldr._validateType;
	
	/*!
	 * EventEmitter v4.2.7 - git.io/ee
	 * Oliver Caldwell
	 * MIT license
	 * @preserve
	 */
	
	var EventEmitter;
	/* jshint ignore:start */
	EventEmitter = (function () {
	
	
		/**
		 * Class for managing events.
		 * Can be extended to provide event functionality in other classes.
		 *
		 * @class EventEmitter Manages event registering and emitting.
		 */
		function EventEmitter() {}
	
		// Shortcuts to improve speed and size
		var proto = EventEmitter.prototype;
		var exports = {};
		
	
		/**
		 * Finds the index of the listener for the event in it's storage array.
		 *
		 * @param {Function[]} listeners Array of listeners to search through.
		 * @param {Function} listener Method to look for.
		 * @return {Number} Index of the specified listener, -1 if not found
		 * @api private
		 */
		function indexOfListener(listeners, listener) {
			var i = listeners.length;
			while (i--) {
				if (listeners[i].listener === listener) {
					return i;
				}
			}
	
			return -1;
		}
	
		/**
		 * Alias a method while keeping the context correct, to allow for overwriting of target method.
		 *
		 * @param {String} name The name of the target method.
		 * @return {Function} The aliased method
		 * @api private
		 */
		function alias(name) {
			return function aliasClosure() {
				return this[name].apply(this, arguments);
			};
		}
	
		/**
		 * Returns the listener array for the specified event.
		 * Will initialise the event object and listener arrays if required.
		 * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
		 * Each property in the object response is an array of listener functions.
		 *
		 * @param {String|RegExp} evt Name of the event to return the listeners from.
		 * @return {Function[]|Object} All listener functions for the event.
		 */
		proto.getListeners = function getListeners(evt) {
			var events = this._getEvents();
			var response;
			var key;
	
			// Return a concatenated array of all matching events if
			// the selector is a regular expression.
			if (evt instanceof RegExp) {
				response = {};
				for (key in events) {
					if (events.hasOwnProperty(key) && evt.test(key)) {
						response[key] = events[key];
					}
				}
			}
			else {
				response = events[evt] || (events[evt] = []);
			}
	
			return response;
		};
	
		/**
		 * Takes a list of listener objects and flattens it into a list of listener functions.
		 *
		 * @param {Object[]} listeners Raw listener objects.
		 * @return {Function[]} Just the listener functions.
		 */
		proto.flattenListeners = function flattenListeners(listeners) {
			var flatListeners = [];
			var i;
	
			for (i = 0; i < listeners.length; i += 1) {
				flatListeners.push(listeners[i].listener);
			}
	
			return flatListeners;
		};
	
		/**
		 * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
		 *
		 * @param {String|RegExp} evt Name of the event to return the listeners from.
		 * @return {Object} All listener functions for an event in an object.
		 */
		proto.getListenersAsObject = function getListenersAsObject(evt) {
			var listeners = this.getListeners(evt);
			var response;
	
			if (listeners instanceof Array) {
				response = {};
				response[evt] = listeners;
			}
	
			return response || listeners;
		};
	
		/**
		 * Adds a listener function to the specified event.
		 * The listener will not be added if it is a duplicate.
		 * If the listener returns true then it will be removed after it is called.
		 * If you pass a regular expression as the event name then the listener will be added to all events that match it.
		 *
		 * @param {String|RegExp} evt Name of the event to attach the listener to.
		 * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.addListener = function addListener(evt, listener) {
			var listeners = this.getListenersAsObject(evt);
			var listenerIsWrapped = typeof listener === 'object';
			var key;
	
			for (key in listeners) {
				if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
					listeners[key].push(listenerIsWrapped ? listener : {
						listener: listener,
						once: false
					});
				}
			}
	
			return this;
		};
	
		/**
		 * Alias of addListener
		 */
		proto.on = alias('addListener');
	
		/**
		 * Semi-alias of addListener. It will add a listener that will be
		 * automatically removed after it's first execution.
		 *
		 * @param {String|RegExp} evt Name of the event to attach the listener to.
		 * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.addOnceListener = function addOnceListener(evt, listener) {
			return this.addListener(evt, {
				listener: listener,
				once: true
			});
		};
	
		/**
		 * Alias of addOnceListener.
		 */
		proto.once = alias('addOnceListener');
	
		/**
		 * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
		 * You need to tell it what event names should be matched by a regex.
		 *
		 * @param {String} evt Name of the event to create.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.defineEvent = function defineEvent(evt) {
			this.getListeners(evt);
			return this;
		};
	
		/**
		 * Uses defineEvent to define multiple events.
		 *
		 * @param {String[]} evts An array of event names to define.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.defineEvents = function defineEvents(evts) {
			for (var i = 0; i < evts.length; i += 1) {
				this.defineEvent(evts[i]);
			}
			return this;
		};
	
		/**
		 * Removes a listener function from the specified event.
		 * When passed a regular expression as the event name, it will remove the listener from all events that match it.
		 *
		 * @param {String|RegExp} evt Name of the event to remove the listener from.
		 * @param {Function} listener Method to remove from the event.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.removeListener = function removeListener(evt, listener) {
			var listeners = this.getListenersAsObject(evt);
			var index;
			var key;
	
			for (key in listeners) {
				if (listeners.hasOwnProperty(key)) {
					index = indexOfListener(listeners[key], listener);
	
					if (index !== -1) {
						listeners[key].splice(index, 1);
					}
				}
			}
	
			return this;
		};
	
		/**
		 * Alias of removeListener
		 */
		proto.off = alias('removeListener');
	
		/**
		 * Adds listeners in bulk using the manipulateListeners method.
		 * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
		 * You can also pass it a regular expression to add the array of listeners to all events that match it.
		 * Yeah, this function does quite a bit. That's probably a bad thing.
		 *
		 * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
		 * @param {Function[]} [listeners] An optional array of listener functions to add.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.addListeners = function addListeners(evt, listeners) {
			// Pass through to manipulateListeners
			return this.manipulateListeners(false, evt, listeners);
		};
	
		/**
		 * Removes listeners in bulk using the manipulateListeners method.
		 * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
		 * You can also pass it an event name and an array of listeners to be removed.
		 * You can also pass it a regular expression to remove the listeners from all events that match it.
		 *
		 * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
		 * @param {Function[]} [listeners] An optional array of listener functions to remove.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.removeListeners = function removeListeners(evt, listeners) {
			// Pass through to manipulateListeners
			return this.manipulateListeners(true, evt, listeners);
		};
	
		/**
		 * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
		 * The first argument will determine if the listeners are removed (true) or added (false).
		 * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
		 * You can also pass it an event name and an array of listeners to be added/removed.
		 * You can also pass it a regular expression to manipulate the listeners of all events that match it.
		 *
		 * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
		 * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
		 * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
			var i;
			var value;
			var single = remove ? this.removeListener : this.addListener;
			var multiple = remove ? this.removeListeners : this.addListeners;
	
			// If evt is an object then pass each of it's properties to this method
			if (typeof evt === 'object' && !(evt instanceof RegExp)) {
				for (i in evt) {
					if (evt.hasOwnProperty(i) && (value = evt[i])) {
						// Pass the single listener straight through to the singular method
						if (typeof value === 'function') {
							single.call(this, i, value);
						}
						else {
							// Otherwise pass back to the multiple function
							multiple.call(this, i, value);
						}
					}
				}
			}
			else {
				// So evt must be a string
				// And listeners must be an array of listeners
				// Loop over it and pass each one to the multiple method
				i = listeners.length;
				while (i--) {
					single.call(this, evt, listeners[i]);
				}
			}
	
			return this;
		};
	
		/**
		 * Removes all listeners from a specified event.
		 * If you do not specify an event then all listeners will be removed.
		 * That means every event will be emptied.
		 * You can also pass a regex to remove all events that match it.
		 *
		 * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.removeEvent = function removeEvent(evt) {
			var type = typeof evt;
			var events = this._getEvents();
			var key;
	
			// Remove different things depending on the state of evt
			if (type === 'string') {
				// Remove all listeners for the specified event
				delete events[evt];
			}
			else if (evt instanceof RegExp) {
				// Remove all events matching the regex.
				for (key in events) {
					if (events.hasOwnProperty(key) && evt.test(key)) {
						delete events[key];
					}
				}
			}
			else {
				// Remove all listeners in all events
				delete this._events;
			}
	
			return this;
		};
	
		/**
		 * Alias of removeEvent.
		 *
		 * Added to mirror the node API.
		 */
		proto.removeAllListeners = alias('removeEvent');
	
		/**
		 * Emits an event of your choice.
		 * When emitted, every listener attached to that event will be executed.
		 * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
		 * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
		 * So they will not arrive within the array on the other side, they will be separate.
		 * You can also pass a regular expression to emit to all events that match it.
		 *
		 * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
		 * @param {Array} [args] Optional array of arguments to be passed to each listener.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.emitEvent = function emitEvent(evt, args) {
			var listeners = this.getListenersAsObject(evt);
			var listener;
			var i;
			var key;
			var response;
	
			for (key in listeners) {
				if (listeners.hasOwnProperty(key)) {
					i = listeners[key].length;
	
					while (i--) {
						// If the listener returns true then it shall be removed from the event
						// The function is executed either with a basic call or an apply if there is an args array
						listener = listeners[key][i];
	
						if (listener.once === true) {
							this.removeListener(evt, listener.listener);
						}
	
						response = listener.listener.apply(this, args || []);
	
						if (response === this._getOnceReturnValue()) {
							this.removeListener(evt, listener.listener);
						}
					}
				}
			}
	
			return this;
		};
	
		/**
		 * Alias of emitEvent
		 */
		proto.trigger = alias('emitEvent');
	
		/**
		 * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
		 * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
		 *
		 * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
		 * @param {...*} Optional additional arguments to be passed to each listener.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.emit = function emit(evt) {
			var args = Array.prototype.slice.call(arguments, 1);
			return this.emitEvent(evt, args);
		};
	
		/**
		 * Sets the current value to check against when executing listeners. If a
		 * listeners return value matches the one set here then it will be removed
		 * after execution. This value defaults to true.
		 *
		 * @param {*} value The new value to check for when executing listeners.
		 * @return {Object} Current instance of EventEmitter for chaining.
		 */
		proto.setOnceReturnValue = function setOnceReturnValue(value) {
			this._onceReturnValue = value;
			return this;
		};
	
		/**
		 * Fetches the current value to check against when executing listeners. If
		 * the listeners return value matches this one then it should be removed
		 * automatically. It will return true by default.
		 *
		 * @return {*|Boolean} The current value to check for or the default, true.
		 * @api private
		 */
		proto._getOnceReturnValue = function _getOnceReturnValue() {
			if (this.hasOwnProperty('_onceReturnValue')) {
				return this._onceReturnValue;
			}
			else {
				return true;
			}
		};
	
		/**
		 * Fetches the events object and creates one if required.
		 *
		 * @return {Object} The events storage object.
		 * @api private
		 */
		proto._getEvents = function _getEvents() {
			return this._events || (this._events = {});
		};
	
		/**
		 * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
		 *
		 * @return {Function} Non conflicting EventEmitter class.
		 */
		EventEmitter.noConflict = function noConflict() {
			exports.EventEmitter = originalGlobalValue;
			return EventEmitter;
		};
	
		return EventEmitter;
	}());
	/* jshint ignore:end */
	
	
	
		var validateTypeFunction = function( value, name ) {
			validateType( value, name, typeof value === "undefined" || typeof value === "function", "Function" );
		};
	
	
	
	
		var superGet, superInit,
			globalEe = new EventEmitter();
	
		function validateTypeEvent( value, name ) {
			validateType( value, name, typeof value === "string" || value instanceof RegExp, "String or RegExp" );
		}
	
		function validateThenCall( method, self ) {
			return function( event, listener ) {
				validatePresence( event, "event" );
				validateTypeEvent( event, "event" );
	
				validatePresence( listener, "listener" );
				validateTypeFunction( listener, "listener" );
	
				return self[ method ].apply( self, arguments );
			};
		}
	
		function off( self ) {
			return validateThenCall( "off", self );
		}
	
		function on( self ) {
			return validateThenCall( "on", self );
		}
	
		function once( self ) {
			return validateThenCall( "once", self );
		}
	
		Cldr.off = off( globalEe );
		Cldr.on = on( globalEe );
		Cldr.once = once( globalEe );
	
		/**
		 * Overload Cldr.prototype.init().
		 */
		superInit = Cldr.prototype.init;
		Cldr.prototype.init = function() {
			var ee;
			this.ee = ee = new EventEmitter();
			this.off = off( ee );
			this.on = on( ee );
			this.once = once( ee );
			superInit.apply( this, arguments );
		};
	
		/**
		 * getOverload is encapsulated, because of cldr/unresolved. If it's loaded
		 * after cldr/event (and note it overwrites .get), it can trigger this
		 * overload again.
		 */
		function getOverload() {
	
			/**
			 * Overload Cldr.prototype.get().
			 */
			superGet = Cldr.prototype.get;
			Cldr.prototype.get = function( path ) {
				var value = superGet.apply( this, arguments );
				path = pathNormalize( path, this.attributes ).join( "/" );
				globalEe.trigger( "get", [ path, value ] );
				this.ee.trigger( "get", [ path, value ] );
				return value;
			};
		}
	
		Cldr._eventInit = getOverload;
		getOverload();
	
		return Cldr;
	
	
	
	
	}));


/***/ },

/***/ 119:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * CLDR JavaScript Library v0.5.4
	 * http://jquery.com/
	 *
	 * Copyright 2013 Rafael Xavier de Souza
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2020-10-22T15:56Z
	 */
	/*!
	 * CLDR JavaScript Library v0.5.4 2020-10-22T15:56Z MIT license © Rafael Xavier
	 * http://git.io/h4lmVg
	 */
	(function( factory ) {
	
		if ( true ) {
			// AMD.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(23) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ( typeof module === "object" && typeof module.exports === "object" ) {
			// Node. CommonJS.
			module.exports = factory( require( "../cldr" ) );
		} else {
			// Global
			factory( Cldr );
		}
	
	}(function( Cldr ) {
	
		// Build optimization hack to avoid duplicating functions across modules.
		var alwaysArray = Cldr._alwaysArray;
	
	
	
		var supplementalMain = function( cldr ) {
	
			var prepend, supplemental;
			
			prepend = function( prepend ) {
				return function( path ) {
					path = alwaysArray( path );
					return cldr.get( [ prepend ].concat( path ) );
				};
			};
	
			supplemental = prepend( "supplemental" );
	
			// Week Data
			// http://www.unicode.org/reports/tr35/tr35-dates.html#Week_Data
			supplemental.weekData = prepend( "supplemental/weekData" );
	
			supplemental.weekData.firstDay = function() {
				return cldr.get( "supplemental/weekData/firstDay/{territory}" ) ||
					cldr.get( "supplemental/weekData/firstDay/001" );
			};
	
			supplemental.weekData.minDays = function() {
				var minDays = cldr.get( "supplemental/weekData/minDays/{territory}" ) ||
					cldr.get( "supplemental/weekData/minDays/001" );
				return parseInt( minDays, 10 );
			};
	
			// Time Data
			// http://www.unicode.org/reports/tr35/tr35-dates.html#Time_Data
			supplemental.timeData = prepend( "supplemental/timeData" );
	
			supplemental.timeData.allowed = function() {
				return cldr.get( "supplemental/timeData/{territory}/_allowed" ) ||
					cldr.get( "supplemental/timeData/001/_allowed" );
			};
	
			supplemental.timeData.preferred = function() {
				return cldr.get( "supplemental/timeData/{territory}/_preferred" ) ||
					cldr.get( "supplemental/timeData/001/_preferred" );
			};
	
			return supplemental;
	
		};
	
	
	
	
		var initSuper = Cldr.prototype.init;
	
		/**
		 * .init() automatically ran on construction.
		 *
		 * Overload .init().
		 */
		Cldr.prototype.init = function() {
			initSuper.apply( this, arguments );
			this.supplemental = supplementalMain( this );
		};
	
		return Cldr;
	
	
	
	
	}));


/***/ },

/***/ 120:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * CLDR JavaScript Library v0.5.4
	 * http://jquery.com/
	 *
	 * Copyright 2013 Rafael Xavier de Souza
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2020-10-22T15:56Z
	 */
	/*!
	 * CLDR JavaScript Library v0.5.4 2020-10-22T15:56Z MIT license © Rafael Xavier
	 * http://git.io/h4lmVg
	 */
	(function( factory ) {
	
		if ( true ) {
			// AMD.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(23) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ( typeof module === "object" && typeof module.exports === "object" ) {
			// Node. CommonJS.
			module.exports = factory( require( "../cldr" ) );
		} else {
			// Global
			factory( Cldr );
		}
	
	}(function( Cldr ) {
	
		// Build optimization hack to avoid duplicating functions across modules.
		var coreLoad = Cldr._coreLoad;
		var jsonMerge = Cldr._jsonMerge;
		var pathNormalize = Cldr._pathNormalize;
		var resourceGet = Cldr._resourceGet;
		var validatePresence = Cldr._validatePresence;
		var validateTypePath = Cldr._validateTypePath;
	
	
	
		var bundleParentLookup = function( Cldr, locale ) {
			var normalizedPath, parent;
	
			if ( locale === "root" ) {
				return;
			}
	
			// First, try to find parent on supplemental data.
			normalizedPath = pathNormalize( [ "supplemental/parentLocales/parentLocale", locale ] );
			parent = resourceGet( Cldr._resolved, normalizedPath ) || resourceGet( Cldr._raw, normalizedPath );
			if ( parent ) {
				return parent;
			}
	
			// Or truncate locale.
			parent = locale.substr( 0, locale.lastIndexOf( Cldr.localeSep ) );
			if ( !parent ) {
				return "root";
			}
	
			return parent;
		};
	
	
	
	
		// @path: normalized path
		var resourceSet = function( data, path, value ) {
			var i,
				node = data,
				length = path.length;
	
			for ( i = 0; i < length - 1; i++ ) {
				if ( !node[ path[ i ] ] ) {
					node[ path[ i ] ] = {};
				}
				node = node[ path[ i ] ];
			}
			node[ path[ i ] ] = value;
		};
	
	
		var itemLookup = (function() {
	
		var lookup;
	
		lookup = function( Cldr, locale, path, attributes, childLocale ) {
			var normalizedPath, parent, value;
	
			// 1: Finish recursion
			// 2: Avoid infinite loop
			if ( typeof locale === "undefined" /* 1 */ || locale === childLocale /* 2 */ ) {
				return;
			}
	
			// Resolve path
			normalizedPath = pathNormalize( path, attributes );
	
			// Check resolved (cached) data first
			// 1: Due to #16, never use the cached resolved non-leaf nodes. It may not
			//    represent its leafs in its entirety.
			value = resourceGet( Cldr._resolved, normalizedPath );
			if ( value !== undefined && typeof value !== "object" /* 1 */ ) {
				return value;
			}
	
			// Check raw data
			value = resourceGet( Cldr._raw, normalizedPath );
	
			if ( value === undefined ) {
				// Or, lookup at parent locale
				parent = bundleParentLookup( Cldr, locale );
				value = lookup( Cldr, parent, path, jsonMerge( attributes, { bundle: parent }), locale );
			}
	
			if ( value !== undefined ) {
				// Set resolved (cached)
				resourceSet( Cldr._resolved, normalizedPath, value );
			}
	
			return value;
		};
	
		return lookup;
	
	}());
	
	
		Cldr._raw = {};
	
		/**
		 * Cldr.load( json [, json, ...] )
		 *
		 * @json [JSON] CLDR data or [Array] Array of @json's.
		 *
		 * Load resolved or unresolved cldr data.
		 * Overwrite Cldr.load().
		 */
		Cldr.load = function() {
			Cldr._raw = coreLoad( Cldr, Cldr._raw, arguments );
		};
	
		/**
		 * Overwrite Cldr.prototype.get().
		 */
		Cldr.prototype.get = function( path ) {
			validatePresence( path, "path" );
			validateTypePath( path, "path" );
	
			// 1: use bundle as locale on item lookup for simplification purposes, because no other extended subtag is used anyway on bundle parent lookup.
			// 2: during init(), this method is called, but bundle is yet not defined. Use "" as a workaround in this very specific scenario.
			return itemLookup( Cldr, this.attributes && this.attributes.bundle /* 1 */ || "" /* 2 */, path, this.attributes );
		};
	
		// In case cldr/unresolved is loaded after cldr/event, we trigger its overloads again. Because, .get is overwritten in here.
		if ( Cldr._eventInit ) {
			Cldr._eventInit();
		}
	
		return Cldr;
	
	
	
	
	}));


/***/ },

/***/ 121:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Globalize v1.6.0
	 *
	 * http://github.com/jquery/globalize
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2020-09-08T11:54Z
	 */
	/*!
	 * Globalize v1.6.0 2020-09-08T11:54Z Released under the MIT license
	 * http://git.io/TrdQbw
	 */
	(function( root, factory ) {
	
		// UMD returnExports
		if ( false ) {
	
			// AMD
			define([
				"cldr",
				"../globalize",
				"cldr/event",
				"cldr/supplemental"
			], factory );
		} else if ( true ) {
	
			// Node, CommonJS
			module.exports = factory( __webpack_require__( 56 ), __webpack_require__( 58 ) );
		} else {
	
			// Global
			factory( root.Cldr, root.Globalize );
		}
	}(this, function( Cldr, Globalize ) {
	
	var createError = Globalize._createError,
		partsJoin = Globalize._partsJoin,
		partsPush = Globalize._partsPush,
		regexpEscape = Globalize._regexpEscape,
		runtimeBind = Globalize._runtimeBind,
		stringPad = Globalize._stringPad,
		validateCldr = Globalize._validateCldr,
		validateDefaultLocale = Globalize._validateDefaultLocale,
		validateParameterPresence = Globalize._validateParameterPresence,
		validateParameterRange = Globalize._validateParameterRange,
		validateParameterType = Globalize._validateParameterType,
		validateParameterTypePlainObject = Globalize._validateParameterTypePlainObject;
	
	
	var createErrorUnsupportedFeature = function( feature ) {
		return createError( "E_UNSUPPORTED", "Unsupported {feature}.", {
			feature: feature
		});
	};
	
	
	
	
	var validateParameterTypeNumber = function( value, name ) {
		validateParameterType(
			value,
			name,
			value === undefined || typeof value === "number",
			"Number"
		);
	};
	
	
	
	
	var validateParameterTypeString = function( value, name ) {
		validateParameterType(
			value,
			name,
			value === undefined || typeof value === "string",
			"a string"
		);
	};
	
	
	
	
	var numberFormatterFn = function( numberToPartsFormatter ) {
		return function numberFormatter( value ) {
			return partsJoin( numberToPartsFormatter( value ));
		};
	};
	
	
	
	
	/**
	 * NumberingSystem( cldr )
	 *
	 * - http://www.unicode.org/reports/tr35/tr35-numbers.html#otherNumberingSystems
	 * - http://cldr.unicode.org/index/bcp47-extension
	 * - http://www.unicode.org/reports/tr35/#u_Extension
	 */
	var numberNumberingSystem = function( cldr ) {
		var nu = cldr.attributes[ "u-nu" ];
	
		if ( nu ) {
			if ( nu === "traditio" ) {
				nu = "traditional";
			}
			if ( [ "native", "traditional", "finance" ].indexOf( nu ) !== -1 ) {
	
				// Unicode locale extension `u-nu` is set using either (native, traditional or
				// finance). So, lookup the respective locale's numberingSystem and return it.
				return cldr.main([ "numbers/otherNumberingSystems", nu ]);
			}
	
			// Unicode locale extension `u-nu` is set with an explicit numberingSystem. Return it.
			return nu;
		}
	
		// Return the default numberingSystem.
		return cldr.main( "numbers/defaultNumberingSystem" );
	};
	
	
	
	
	/**
	 * Compact( name, cldr )
	 *
	 * @compactType [String] Compact mode, `short` or `long`.
	 *
	 * @cldr [Cldr instance].
	 *
	 * Return the localized compact map for the given compact mode.
	 */
	var numberCompact = function( compactType, cldr ) {
		var maxExponent = 0;
	
		var object = cldr.main([
			"numbers/decimalFormats-numberSystem-" + numberNumberingSystem( cldr ),
			compactType,
			"decimalFormat"
		]);
	
		object = Object.keys( object ).reduce(function( newObject, compactKey ) {
			var numberExponent = compactKey.split( "0" ).length - 1;
			var pluralForm = compactKey.split( "-" )[ 2 ];
			newObject[ numberExponent ] = newObject[ numberExponent ] || {};
			newObject[ numberExponent ][ pluralForm ] = object[ compactKey ];
			maxExponent = Math.max( numberExponent, maxExponent );
			return newObject;
		}, {});
	
		object.maxExponent = maxExponent;
	
		return object;
	};
	
	
	
	
	/**
	 * nuMap( cldr )
	 *
	 * @cldr [Cldr instance].
	 *
	 * Return digits map if numbering system is different than `latn`.
	 */
	var numberNumberingSystemDigitsMap = function( cldr ) {
		var aux,
			nu = numberNumberingSystem( cldr );
	
		if ( nu === "latn" ) {
			return;
		}
	
		aux = cldr.supplemental([ "numberingSystems", nu ]);
	
		if ( aux._type !== "numeric" ) {
			throw createErrorUnsupportedFeature( "`" + aux._type + "` numbering system" );
		}
	
		return aux._digits;
	};
	
	
	
	
	/**
	 * EBNF representation:
	 *
	 * number_pattern_re =        prefix?
	 *                            padding?
	 *                            (integer_fraction_pattern | significant_pattern)
	 *                            scientific_notation?
	 *                            suffix?
	 *
	 * prefix =                   non_number_stuff
	 *
	 * padding =                  "*" regexp(.)
	 *
	 * integer_fraction_pattern = integer_pattern
	 *                            fraction_pattern?
	 *
	 * integer_pattern =          regexp([#,]*[0,]*0+)
	 *
	 * fraction_pattern =         "." regexp(0*[0-9]*#*)
	 *
	 * significant_pattern =      regexp([#,]*@+#*)
	 *
	 * scientific_notation =      regexp(E\+?0+)
	 *
	 * suffix =                   non_number_stuff
	 *
	 * non_number_stuff =         regexp(('[^']+'|''|[^*#@0,.E])*)
	 *
	 *
	 * Regexp groups:
	 *
	 *  0: number_pattern_re
	 *  1: prefix
	 *  2: -
	 *  3: -
	 *  4: padding
	 *  5: (integer_fraction_pattern | significant_pattern)
	 *  6: integer_fraction_pattern
	 *  7: integer_pattern
	 *  8: fraction_pattern
	 *  9: significant_pattern
	 * 10: scientific_notation
	 * 11: suffix
	 * 12: -
	 */
	var numberPatternRe = ( /^(('([^']|'')*'|[^*#@0,.E])*)(\*.)?((([#,]*[0,]*0+)(\.0*[0-9]*#*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/ );
	
	
	
	
	/**
	 * format( number, pattern )
	 *
	 * @number [Number].
	 *
	 * @pattern [String] raw pattern for numbers.
	 *
	 * Return the formatted number.
	 * ref: http://www.unicode.org/reports/tr35/tr35-numbers.html
	 */
	var numberPatternProperties = function( pattern ) {
		var aux1, aux2, fractionPattern, integerFractionOrSignificantPattern, integerPattern,
			maximumFractionDigits, maximumSignificantDigits, minimumFractionDigits,
			minimumIntegerDigits, minimumSignificantDigits, padding, prefix, primaryGroupingSize,
			roundIncrement, scientificNotation, secondaryGroupingSize, significantPattern, suffix;
	
		pattern = pattern.match( numberPatternRe );
		if ( !pattern ) {
			throw new Error( "Invalid pattern: " + pattern );
		}
	
		prefix = pattern[ 1 ];
		padding = pattern[ 4 ];
		integerFractionOrSignificantPattern = pattern[ 5 ];
		significantPattern = pattern[ 9 ];
		scientificNotation = pattern[ 10 ];
		suffix = pattern[ 11 ];
	
		// Significant digit format
		if ( significantPattern ) {
			significantPattern.replace( /(@+)(#*)/, function( match, minimumSignificantDigitsMatch, maximumSignificantDigitsMatch ) {
				minimumSignificantDigits = minimumSignificantDigitsMatch.length;
				maximumSignificantDigits = minimumSignificantDigits +
					maximumSignificantDigitsMatch.length;
			});
	
		// Integer and fractional format
		} else {
			fractionPattern = pattern[ 8 ];
			integerPattern = pattern[ 7 ];
	
			if ( fractionPattern ) {
	
				// Minimum fraction digits, and rounding.
				fractionPattern.replace( /[0-9]+/, function( match ) {
					minimumFractionDigits = match;
				});
				if ( minimumFractionDigits ) {
					roundIncrement = +( "0." + minimumFractionDigits );
					minimumFractionDigits = minimumFractionDigits.length;
				} else {
					minimumFractionDigits = 0;
				}
	
				// Maximum fraction digits
				// 1: ignore decimal character
				maximumFractionDigits = fractionPattern.length - 1 /* 1 */;
			} else {
				minimumFractionDigits = 0;
				maximumFractionDigits = 0;
			}
	
			// Minimum integer digits
			integerPattern.replace( /0+$/, function( match ) {
				minimumIntegerDigits = match.length;
			});
		}
	
		// Scientific notation
		if ( scientificNotation ) {
			throw createErrorUnsupportedFeature({
				feature: "scientific notation (not implemented)"
			});
		}
	
		// Padding
		if ( padding ) {
			throw createErrorUnsupportedFeature({
				feature: "padding (not implemented)"
			});
		}
	
		// Grouping
		if ( ( aux1 = integerFractionOrSignificantPattern.lastIndexOf( "," ) ) !== -1 ) {
	
			// Primary grouping size is the interval between the last group separator and the end of
			// the integer (or the end of the significant pattern).
			aux2 = integerFractionOrSignificantPattern.split( "." )[ 0 ];
			primaryGroupingSize = aux2.length - aux1 - 1;
	
			// Secondary grouping size is the interval between the last two group separators.
			if ( ( aux2 = integerFractionOrSignificantPattern.lastIndexOf( ",", aux1 - 1 ) ) !== -1 ) {
				secondaryGroupingSize = aux1 - 1 - aux2;
			}
		}
	
		// Return:
		//  0: @prefix String
		//  1: @padding Array [ <character>, <count> ] TODO
		//  2: @minimumIntegerDigits non-negative integer Number value indicating the minimum integer
		//        digits to be used. Numbers will be padded with leading zeroes if necessary.
		//  3: @minimumFractionDigits and
		//  4: @maximumFractionDigits are non-negative integer Number values indicating the minimum and
		//        maximum fraction digits to be used. Numbers will be rounded or padded with trailing
		//        zeroes if necessary.
		//  5: @minimumSignificantDigits and
		//  6: @maximumSignificantDigits are positive integer Number values indicating the minimum and
		//        maximum fraction digits to be shown. Either none or both of these properties are
		//        present; if they are, they override minimum and maximum integer and fraction digits
		//        – the formatter uses however many integer and fraction digits are required to display
		//        the specified number of significant digits.
		//  7: @roundIncrement Decimal round increment or null
		//  8: @primaryGroupingSize
		//  9: @secondaryGroupingSize
		// 10: @suffix String
		return [
			prefix,
			padding,
			minimumIntegerDigits,
			minimumFractionDigits,
			maximumFractionDigits,
			minimumSignificantDigits,
			maximumSignificantDigits,
			roundIncrement,
			primaryGroupingSize,
			secondaryGroupingSize,
			suffix
		];
	};
	
	
	
	
	/**
	 * Symbol( name, cldr )
	 *
	 * @name [String] Symbol name.
	 *
	 * @cldr [Cldr instance].
	 *
	 * Return the localized symbol given its name.
	 */
	var numberSymbol = function( name, cldr ) {
		return cldr.main([
			"numbers/symbols-numberSystem-" + numberNumberingSystem( cldr ),
			name
		]);
	};
	
	
	
	
	var numberSymbolName = {
		".": "decimal",
		",": "group",
		"%": "percentSign",
		"+": "plusSign",
		"-": "minusSign",
		"E": "exponential",
		"\u2030": "perMille"
	};
	
	
	
	
	/**
	 * symbolMap( cldr )
	 *
	 * @cldr [Cldr instance].
	 *
	 * Return the (localized symbol, pattern symbol) key value pair, eg. {
	 *   ".": "٫",
	 *   ",": "٬",
	 *   "%": "٪",
	 *   ...
	 * };
	 */
	var numberSymbolMap = function( cldr ) {
		var symbol,
			symbolMap = {};
	
		for ( symbol in numberSymbolName ) {
			symbolMap[ symbol ] = numberSymbol( numberSymbolName[ symbol ], cldr );
		}
	
		return symbolMap;
	};
	
	
	
	
	var numberTruncate = function( value ) {
		if ( isNaN( value ) ) {
			return NaN;
		}
		return Math[ value < 0 ? "ceil" : "floor" ]( value );
	};
	
	
	
	
	/**
	 * round( method )
	 *
	 * @method [String] with either "round", "ceil", "floor", or "truncate".
	 *
	 * Return function( value, incrementOrExp ):
	 *
	 *   @value [Number] eg. 123.45.
	 *
	 *   @incrementOrExp [Number] optional, eg. 0.1; or
	 *     [Object] Either { increment: <value> } or { exponent: <value> }
	 *
	 *   Return the rounded number, eg:
	 *   - round( "round" )( 123.45 ): 123;
	 *   - round( "ceil" )( 123.45 ): 124;
	 *   - round( "floor" )( 123.45 ): 123;
	 *   - round( "truncate" )( 123.45 ): 123;
	 *   - round( "round" )( 123.45, 0.1 ): 123.5;
	 *   - round( "round" )( 123.45, 10 ): 120;
	 *
	 *   Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
	 *   Ref: #376
	 */
	var numberRound = function( method ) {
		method = method || "round";
		method = method === "truncate" ? numberTruncate : Math[ method ];
	
		return function( value, incrementOrExp ) {
			var exp, increment;
	
			value = +value;
	
			// If the value is not a number, return NaN.
			if ( isNaN( value ) ) {
				return NaN;
			}
	
			// Exponent given.
			if ( typeof incrementOrExp === "object" && incrementOrExp.exponent ) {
				exp = +incrementOrExp.exponent;
				increment = 1;
	
				if ( exp === 0 ) {
					return method( value );
				}
	
				// If the exp is not an integer, return NaN.
				if ( !( typeof exp === "number" && exp % 1 === 0 ) ) {
					return NaN;
				}
	
			// Increment given.
			} else {
				increment = +incrementOrExp || 1;
	
				if ( increment === 1 ) {
					return method( value );
				}
	
				// If the increment is not a number, return NaN.
				if ( isNaN( increment ) ) {
					return NaN;
				}
	
				increment = increment.toExponential().split( "e" );
				exp = +increment[ 1 ];
				increment = +increment[ 0 ];
			}
	
			// Shift & Round
			value = value.toString().split( "e" );
			value[ 0 ] = +value[ 0 ] / increment;
			value[ 1 ] = value[ 1 ] ? ( +value[ 1 ] - exp ) : -exp;
			value = method( +( value[ 0 ] + "e" + value[ 1 ] ) );
	
			// Shift back
			value = value.toString().split( "e" );
			value[ 0 ] = +value[ 0 ] * increment;
			value[ 1 ] = value[ 1 ] ? ( +value[ 1 ] + exp ) : exp;
			return +( value[ 0 ] + "e" + value[ 1 ] );
		};
	};
	
	
	
	
	/**
	 * formatProperties( pattern, cldr [, options] )
	 *
	 * @pattern [String] raw pattern for numbers.
	 *
	 * @cldr [Cldr instance].
	 *
	 * @options [Object]:
	 * - minimumIntegerDigits [Number]
	 * - minimumFractionDigits, maximumFractionDigits [Number]
	 * - minimumSignificantDigits, maximumSignificantDigits [Number]
	 * - round [String] "ceil", "floor", "round" (default), or "truncate".
	 * - useGrouping [Boolean] default true.
	 *
	 * Return the processed properties that will be used in number/format.
	 * ref: http://www.unicode.org/reports/tr35/tr35-numbers.html
	 */
	var numberFormatProperties = function( pattern, cldr, options ) {
		var negativePattern, negativePrefix, negativeProperties, negativeSuffix, positivePattern,
			roundFn, properties;
	
		function getOptions( attribute, propertyIndex ) {
			if ( attribute in options ) {
				properties[ propertyIndex ] = options[ attribute ];
			}
		}
	
		options = options || {};
		pattern = pattern.split( ";" );
	
		positivePattern = pattern[ 0 ];
	
		negativePattern = pattern[ 1 ] || "-" + positivePattern;
		negativeProperties = numberPatternProperties( negativePattern );
		negativePrefix = negativeProperties[ 0 ];
		negativeSuffix = negativeProperties[ 10 ];
	
		// Have runtime code to refer to numberRound() instead of including it explicitly.
		roundFn = numberRound( options.round );
		roundFn.generatorString = function() {
			return "numberRound(" + ( options.round ? "\"" + options.round + "\"" : "" ) + ")";
		};
	
		properties = numberPatternProperties( positivePattern ).concat([
			positivePattern,
			negativePrefix + positivePattern + negativeSuffix,
			negativePrefix,
			negativeSuffix,
			roundFn,
			numberSymbol( "infinity", cldr ),
			numberSymbol( "nan", cldr ),
			numberSymbolMap( cldr ),
			numberNumberingSystemDigitsMap( cldr )
		]);
	
		if ( options.compact ) {
	
			// The compact digits number pattern is always `0+`, so override the following properties.
			// Note: minimumIntegerDigits would actually range from `0` to `000` based on the scale of
			// the value to be formatted, though we're always using 1 as a simplification, because the
			// number won't be zero-padded since we chose the right format based on the scale, i.e.,
			// we'd never see something like `003M` anyway.
			properties[ 2 ] = 1; // minimumIntegerDigits
			properties[ 3 ] = 0; // minimumFractionDigits
			properties[ 4 ] = 0; // maximumFractionDigits
			properties[ 5 ] = // minimumSignificantDigits &
				properties[ 6 ] = undefined ; // maximumSignificantDigits
	
			properties[20] = numberCompact( options.compact, cldr );
		}
	
		getOptions( "minimumIntegerDigits", 2 );
		getOptions( "minimumFractionDigits", 3 );
		getOptions( "maximumFractionDigits", 4 );
		getOptions( "minimumSignificantDigits", 5 );
		getOptions( "maximumSignificantDigits", 6 );
	
		// Grouping separators
		if ( options.useGrouping === false ) {
			properties[ 8 ] = null;
		}
	
		// Normalize number of digits if only one of either minimumFractionDigits or
		// maximumFractionDigits is passed in as an option
		if ( "minimumFractionDigits" in options && !( "maximumFractionDigits" in options ) ) {
	
			// maximumFractionDigits = Math.max( minimumFractionDigits, maximumFractionDigits );
			properties[ 4 ] = Math.max( properties[ 3 ], properties[ 4 ] );
		} else if ( !( "minimumFractionDigits" in options ) &&
				"maximumFractionDigits" in options ) {
	
			// minimumFractionDigits = Math.min( minimumFractionDigits, maximumFractionDigits );
			properties[ 3 ] = Math.min( properties[ 3 ], properties[ 4 ] );
		}
	
		// Return:
		// 0-10: see number/pattern-properties.
		// 11: @positivePattern [String] Positive pattern.
		// 12: @negativePattern [String] Negative pattern.
		// 13: @negativePrefix [String] Negative prefix.
		// 14: @negativeSuffix [String] Negative suffix.
		// 15: @round [Function] Round function.
		// 16: @infinitySymbol [String] Infinity symbol.
		// 17: @nanSymbol [String] NaN symbol.
		// 18: @symbolMap [Object] A bunch of other symbols.
		// 19: @nuDigitsMap [Array] Digits map if numbering system is different than `latn`.
		// 20: @compactMap [Object] Map of per-digit-count format patterns for specified compact mode.
		return properties;
	};
	
	
	
	
	/**
	 * Generated by:
	 *
	 * var regenerate = require( "regenerate" );
	 * var formatSymbols = require( * "unicode-8.0.0/General_Category/Format/symbols" );
	 * regenerate().add( formatSymbols ).toString();
	 *
	 * https://github.com/mathiasbynens/regenerate
	 * https://github.com/mathiasbynens/unicode-8.0.0
	 */
	var regexpCfG = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/g;
	
	
	
	
	/**
	 * Generated by:
	 *
	 * var regenerate = require( "regenerate" );
	 * var dashSymbols = require( * "unicode-8.0.0/General_Category/Dash_Punctuation/symbols" );
	 * regenerate().add( dashSymbols ).toString();
	 *
	 * https://github.com/mathiasbynens/regenerate
	 * https://github.com/mathiasbynens/unicode-8.0.0
	 *
	 * NOTE: In addition to [:dash:],  the below includes MINUS SIGN U+2212.
	 */
	var regexpDashG = /[\-\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D\u2212]/g;
	
	
	
	
	/**
	 * Generated by:
	 *
	 * var regenerate = require( "regenerate" );
	 * var spaceSeparatorSymbols = require( "unicode-8.0.0/General_Category/Space_Separator/symbols" );
	 * regenerate().add( spaceSeparatorSymbols ).toString();
	 *
	 * https://github.com/mathiasbynens/regenerate
	 * https://github.com/mathiasbynens/unicode-8.0.0
	 */
	var regexpZsG = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/g;
	
	
	
	
	/**
	 * Loose Matching:
	 * - Ignore all format characters, which includes RLM, LRM or ALM used to control BIDI
	 *   formatting.
	 * - Map all characters in [:Zs:] to U+0020 SPACE;
	 * - Map all characters in [:Dash:] to U+002D HYPHEN-MINUS;
	 */
	var looseMatching = function( value ) {
		return value
			.replace( regexpCfG, "" )
			.replace( regexpDashG, "-" )
			.replace( regexpZsG, " " );
	};
	
	
	
	
	/**
	 * parse( value, properties )
	 *
	 * @value [String].
	 *
	 * @properties [Object] Parser properties is a reduced pre-processed cldr
	 * data set returned by numberParserProperties().
	 *
	 * Return the parsed Number (including Infinity) or NaN when value is invalid.
	 * ref: http://www.unicode.org/reports/tr35/tr35-numbers.html
	 */
	var numberParse = function( value, properties ) {
		var grammar, invertedNuDigitsMap, invertedSymbolMap, negative, number, prefix, prefixNSuffix,
			suffix, tokenizer, valid;
	
		// Grammar:
		// - Value <=           NaN | PositiveNumber | NegativeNumber
		// - PositiveNumber <=  PositivePrefix NumberOrInf PositiveSufix
		// - NegativeNumber <=  NegativePrefix NumberOrInf
		// - NumberOrInf <=     Number | Inf
		grammar = [
			[ "nan" ],
			[ "prefix", "infinity", "suffix" ],
			[ "prefix", "number", "suffix" ],
			[ "negativePrefix", "infinity", "negativeSuffix" ],
			[ "negativePrefix", "number", "negativeSuffix" ]
		];
	
		invertedSymbolMap = properties[ 0 ];
		invertedNuDigitsMap = properties[ 1 ] || {};
		tokenizer = properties[ 2 ];
	
		value = looseMatching( value );
	
		function parse( type ) {
			return function( lexeme ) {
	
				// Reverse localized symbols and numbering system.
				lexeme = lexeme.split( "" ).map(function( character ) {
					return invertedSymbolMap[ character ] ||
						invertedNuDigitsMap[ character ] ||
						character;
				}).join( "" );
	
				switch ( type ) {
					case "infinity":
						number = Infinity;
						break;
	
					case "nan":
						number = NaN;
						break;
	
					case "number":
	
						// Remove grouping separators.
						lexeme = lexeme.replace( /,/g, "" );
	
						number = +lexeme;
						break;
	
					case "prefix":
					case "negativePrefix":
						prefix = lexeme;
						break;
	
					case "suffix":
						suffix = lexeme;
						break;
	
					case "negativeSuffix":
						suffix = lexeme;
						negative = true;
						break;
	
					// This should never be reached.
					default:
						throw new Error( "Internal error" );
				}
				return "";
			};
		}
	
		function tokenizeNParse( _value, grammar ) {
			return grammar.some(function( statement ) {
				var value = _value;
	
				// The whole grammar statement should be used (i.e., .every() return true) and value be
				// entirely consumed (i.e., !value.length).
				return statement.every(function( type ) {
					if ( value.match( tokenizer[ type ] ) === null ) {
						return false;
					}
	
					// Consume and parse it.
					value = value.replace( tokenizer[ type ], parse( type ) );
					return true;
				}) && !value.length;
			});
		}
	
		valid = tokenizeNParse( value, grammar );
	
		// NaN
		if ( !valid || isNaN( number ) ) {
			return NaN;
		}
	
		prefixNSuffix = "" + prefix + suffix;
	
		// Percent
		if ( prefixNSuffix.indexOf( "%" ) !== -1 ) {
			number /= 100;
	
		// Per mille
		} else if ( prefixNSuffix.indexOf( "\u2030" ) !== -1 ) {
			number /= 1000;
		}
	
		// Negative number
		if ( negative ) {
			number *= -1;
		}
	
		return number;
	};
	
	
	
	
	var numberParserFn = function( properties ) {
		return function numberParser( value ) {
			validateParameterPresence( value, "value" );
			validateParameterTypeString( value, "value" );
	
			return numberParse( value, properties );
		};
	
	};
	
	
	
	
	/**
	 * symbolMap( cldr )
	 *
	 * @cldr [Cldr instance].
	 *
	 * Return the (localized symbol, pattern symbol) key value pair, eg. {
	 *   "٫": ".",
	 *   "٬": ",",
	 *   "٪": "%",
	 *   ...
	 * };
	 */
	var numberSymbolInvertedMap = function( cldr ) {
		var symbol,
			symbolMap = {};
	
		for ( symbol in numberSymbolName ) {
			symbolMap[ numberSymbol( numberSymbolName[ symbol ], cldr ) ] = symbol;
		}
	
		return symbolMap;
	};
	
	
	
	
	/**
	 * objectMap( object, fn)
	 *
	 * - object
	 *
	 * - fn( pair ) => pair
	 */
	var objectMap = function( object, fn ) {
		return Object.keys( object ).map(function( key ) {
			return fn([ key, object[ key ] ]);
		}).reduce(function( object, pair ) {
			object[ pair[ 0 ] ] = pair[ 1 ];
			return object;
		}, {});
	};
	
	
	
	
	/**
	 * removeLiteralQuotes( string )
	 *
	 * Return:
	 * - `'` if input string is `''`.
	 * - `o'clock` if input string is `'o''clock'`.
	 * - `foo` if input string is `foo`, i.e., return the same value in case it isn't a single-quoted
	 *   string.
	 */
	var removeLiteralQuotes = function( string ) {
		if ( string[ 0 ] + string[ string.length - 1 ] !== "''" ) {
			return string;
		}
		if ( string === "''" ) {
			return "'";
		}
		return string.replace( /''/g, "'" ).slice( 1, -1 );
	};
	
	
	
	
	/**
	 * parseProperties( pattern, cldr )
	 *
	 * @pattern [String] raw pattern for numbers.
	 *
	 * @cldr [Cldr instance].
	 *
	 * Return parser properties, used to feed parser function.
	 *
	 * TODO:
	 * - Scientific_notation;
	 * - Padding;
	 */
	var numberParseProperties = function( pattern, cldr, options ) {
		var aux, decimalSymbolRe, digitsRe, groupingSeparatorRe, infinitySymbol, invertedNuDigitsMap,
			invertedSymbolMap, maximumFractionDigits, maximumSignificantDigits,
			minimumSignificantDigits, nanSymbol, negativePrefix, negativeSuffix, nuDigitsMap,
			numberTokenizer, prefix, primaryGroupingSize, secondaryGroupingSize, suffix, symbolMap,
			formatProperties = numberFormatProperties( pattern, cldr, options );
	
		prefix = looseMatching( formatProperties[ 0 ] );
		maximumFractionDigits = formatProperties[ 4 ];
		minimumSignificantDigits = formatProperties[ 5 ];
		maximumSignificantDigits = formatProperties[ 6 ];
		primaryGroupingSize = formatProperties[ 8 ];
		secondaryGroupingSize = formatProperties[ 9 ];
		suffix = looseMatching( formatProperties[ 10 ] );
		negativePrefix = looseMatching( formatProperties[ 13 ] );
		negativeSuffix = looseMatching( formatProperties[ 14 ] );
		infinitySymbol = looseMatching( formatProperties[ 16 ] );
		nanSymbol = looseMatching( formatProperties[ 17 ] );
		symbolMap = objectMap( formatProperties[ 18 ], function( pair ) {
			return [ pair[ 0 ], looseMatching( pair[ 1 ] ) ];
		});
		nuDigitsMap = formatProperties[ 19 ];
	
		invertedSymbolMap = objectMap( numberSymbolInvertedMap( cldr ), function( pair ) {
			return [ looseMatching( pair[ 0 ] ), pair[ 1 ] ];
		});
	
		digitsRe = nuDigitsMap ? "[" + nuDigitsMap + "]" : "\\d";
		groupingSeparatorRe = regexpEscape( symbolMap[ "," ] );
		decimalSymbolRe = regexpEscape( symbolMap[ "." ] );
	
		if ( nuDigitsMap ) {
			invertedNuDigitsMap = nuDigitsMap.split( "" ).reduce(function( object, localizedDigit, i ) {
				object[ localizedDigit ] = String( i );
				return object;
			}, {} );
		}
	
		aux = [ prefix, suffix, negativePrefix, negativeSuffix ].map(function( value ) {
			return value.replace( /('([^']|'')+'|'')|./g, function( character, literal ) {
	
				// Literals
				if ( literal ) {
					return removeLiteralQuotes( literal );
				}
	
				// Symbols
				character = character.replace( /[\-+E%\u2030]/, function( symbol ) {
					return symbolMap[ symbol ];
				});
	
				return character;
			});
		});
	
		prefix = aux[ 0 ];
		suffix = aux[ 1 ];
		negativePrefix = aux[ 2 ];
		negativeSuffix = aux[ 3 ];
	
		// Number
		//
		// number_re =                       integer fraction?
		//
		// integer =                         digits | digits_using_grouping_separators
		//
		// fraction =                        regexp((.\d+)?)
		//
		// digits =                          regexp(\d+)
		//
		// digits_w_grouping_separators =    digits_w_1_grouping_separators |
		//                                   digits_w_2_grouping_separators
		//
		// digits_w_1_grouping_separators =  regexp(\d{1,3}(,\d{3})+)
		//
		// digits_w_2_grouping_separators =  regexp(\d{1,2}((,\d{2})*(,\d{3})))
	
		// Integer part
		numberTokenizer = digitsRe + "+";
	
		// Grouping separators
		if ( primaryGroupingSize ) {
			if ( secondaryGroupingSize ) {
				aux = digitsRe + "{1," + secondaryGroupingSize + "}((" + groupingSeparatorRe +
					digitsRe + "{" + secondaryGroupingSize + "})*(" + groupingSeparatorRe +
					digitsRe + "{" + primaryGroupingSize + "}))";
			} else {
				aux = digitsRe + "{1," + primaryGroupingSize + "}(" + groupingSeparatorRe +
					digitsRe + "{" + primaryGroupingSize + "})+";
			}
			numberTokenizer = "(" + aux + "|" + numberTokenizer + ")";
		}
	
		// Fraction part? Only included if 1 or 2.
		// 1: Using significant digit format.
		// 2: Using integer and fractional format && it has a maximumFractionDigits.
		if ( !isNaN( minimumSignificantDigits * maximumSignificantDigits ) || /* 1 */
					maximumFractionDigits /* 2 */ ) {
	
			// 1: Handle trailing decimal separator, e.g., `"1." => `1``.
			aux = decimalSymbolRe + digitsRe + "+";
			numberTokenizer = numberTokenizer + "(" + aux + "|" + decimalSymbolRe /* 1 */ + ")?" +
	
				// Handle non-padded decimals, e.g., `".12"` => `0.12` by making the integer part
				// optional.
				"|(" + numberTokenizer + ")?" + aux;
	
			numberTokenizer = "(" + numberTokenizer + ")";
		}
	
		// 0: @invertedSymbolMap [Object] Inverted symbol map.
		// 1: @invertedNuDigitsMap [Object] Inverted digits map if numbering system is different than
		//    `latn`.
		// 2: @tokenizer [Object] Tokenizer map, used by parser to consume input.
		return [
			invertedSymbolMap,
			invertedNuDigitsMap,
			{
				infinity: new RegExp( "^" + regexpEscape( infinitySymbol ) ),
				nan:  new RegExp( "^" + regexpEscape( nanSymbol ) ),
				negativePrefix: new RegExp( "^" + regexpEscape( negativePrefix ) ),
				negativeSuffix: new RegExp( "^" + regexpEscape( negativeSuffix ) ),
				number: new RegExp( "^" + numberTokenizer ),
				prefix: new RegExp( "^" + regexpEscape( prefix ) ),
				suffix: new RegExp( "^" + regexpEscape( suffix ) )
			}
		];
	
	};
	
	
	
	
	/**
	 * Pattern( style )
	 *
	 * @style [String] "decimal" (default) or "percent".
	 *
	 * @cldr [Cldr instance].
	 */
	var numberPattern = function( style, cldr ) {
		if ( style !== "decimal" && style !== "percent" ) {
			throw new Error( "Invalid style" );
		}
	
		return cldr.main([
			"numbers",
			style + "Formats-numberSystem-" + numberNumberingSystem( cldr ),
			"standard"
		]);
	};
	
	
	
	
	/**
	 * EBNF representation:
	 *
	 * compact_pattern_re =       prefix?
	 *                            number_pattern_re
	 *                            suffix?
	 *
	 * number_pattern_re =        0+
	 *
	 * Regexp groups:
	 *
	 *  0: compact_pattern_re
	 *  1: prefix
	 *  2: number_pattern_re (the number pattern to use in compact mode)
	 *  3: suffix
	 */
	var numberCompactPatternRe = ( /^([^0]*)(0+)([^0]*)$/ );
	
	
	
	
	/**
	 * goupingSeparator( number, primaryGroupingSize, secondaryGroupingSize )
	 *
	 * @number [Number].
	 *
	 * @primaryGroupingSize [Number]
	 *
	 * @secondaryGroupingSize [Number]
	 *
	 * Return the formatted number with group separator.
	 */
	var numberFormatGroupingSeparator = function( number, primaryGroupingSize, secondaryGroupingSize ) {
		var index,
			currentGroupingSize = primaryGroupingSize,
			ret = "",
			sep = ",",
			switchToSecondary = secondaryGroupingSize ? true : false;
	
		number = String( number ).split( "." );
		index = number[ 0 ].length;
	
		while ( index > currentGroupingSize ) {
			ret = number[ 0 ].slice( index - currentGroupingSize, index ) +
				( ret.length ? sep : "" ) + ret;
			index -= currentGroupingSize;
			if ( switchToSecondary ) {
				currentGroupingSize = secondaryGroupingSize;
				switchToSecondary = false;
			}
		}
	
		number[ 0 ] = number[ 0 ].slice( 0, index ) + ( ret.length ? sep : "" ) + ret;
		return number.join( "." );
	};
	
	
	
	
	/**
	 * integerFractionDigits( number, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, round, roundIncrement )
	 *
	 * @number [Number]
	 *
	 * @minimumIntegerDigits [Number]
	 *
	 * @minimumFractionDigits [Number]
	 *
	 * @maximumFractionDigits [Number]
	 *
	 * @round [Function]
	 *
	 * @roundIncrement [Function]
	 *
	 * Return the formatted integer and fraction digits.
	 */
	var numberFormatIntegerFractionDigits = function( number, minimumIntegerDigits, minimumFractionDigits, maximumFractionDigits, round,
		roundIncrement ) {
	
		// Fraction
		if ( maximumFractionDigits ) {
	
			// Rounding
			if ( roundIncrement ) {
				number = round( number, roundIncrement );
	
			// Maximum fraction digits
			} else {
				number = round( number, { exponent: -maximumFractionDigits } );
			}
	
		} else {
			number = round( number );
		}
	
		number = String( number );
	
		// Maximum integer digits (post string phase)
		if ( maximumFractionDigits && /e-/.test( number ) ) {
	
			// Use toFixed( maximumFractionDigits ) to make sure small numbers like 1e-7 are
			// displayed using plain digits instead of scientific notation.
			// 1: Remove leading decimal zeros.
			// 2: Remove leading decimal separator.
			// Note: String() is still preferred so it doesn't mess up with a number precision
			// unnecessarily, e.g., (123456789.123).toFixed(10) === "123456789.1229999959",
			// String(123456789.123) === "123456789.123".
			number = ( +number ).toFixed( maximumFractionDigits )
				.replace( /0+$/, "" ) /* 1 */
				.replace( /\.$/, "" ) /* 2 */;
		}
	
		// Minimum fraction digits (post string phase)
		if ( minimumFractionDigits ) {
			number = number.split( "." );
			number[ 1 ] = stringPad( number[ 1 ] || "", minimumFractionDigits, true );
			number = number.join( "." );
		}
	
		// Minimum integer digits
		if ( minimumIntegerDigits ) {
			number = number.split( "." );
			number[ 0 ] = stringPad( number[ 0 ], minimumIntegerDigits );
			number = number.join( "." );
		}
	
		return number;
	};
	
	
	
	
	/**
	 * toPrecision( number, precision, round )
	 *
	 * @number (Number)
	 *
	 * @precision (Number) significant figures precision (not decimal precision).
	 *
	 * @round (Function)
	 *
	 * Return number.toPrecision( precision ) using the given round function.
	 */
	var numberToPrecision = function( number, precision, round ) {
		var roundOrder;
	
		if ( number === 0 ) {  // Fix #706
			return number;
		}
	
		roundOrder = Math.ceil( Math.log( Math.abs( number ) ) / Math.log( 10 ) );
		roundOrder -= precision;
	
		return round( number, { exponent: roundOrder } );
	};
	
	
	
	
	/**
	 * toPrecision( number, minimumSignificantDigits, maximumSignificantDigits, round )
	 *
	 * @number [Number]
	 *
	 * @minimumSignificantDigits [Number]
	 *
	 * @maximumSignificantDigits [Number]
	 *
	 * @round [Function]
	 *
	 * Return the formatted significant digits number.
	 */
	var numberFormatSignificantDigits = function( number, minimumSignificantDigits, maximumSignificantDigits, round ) {
		var atMinimum, atMaximum;
	
		// Sanity check.
		if ( minimumSignificantDigits > maximumSignificantDigits ) {
			maximumSignificantDigits = minimumSignificantDigits;
		}
	
		atMinimum = numberToPrecision( number, minimumSignificantDigits, round );
		atMaximum = numberToPrecision( number, maximumSignificantDigits, round );
	
		// Use atMaximum only if it has more significant digits than atMinimum.
		number = +atMinimum === +atMaximum ? atMinimum : atMaximum;
	
		// Expand integer numbers, eg. 123e5 to 12300.
		number = ( +number ).toString( 10 );
	
		if ( ( /e/ ).test( number ) ) {
			throw createErrorUnsupportedFeature({
				feature: "integers out of (1e21, 1e-7)"
			});
		}
	
		// Add trailing zeros if necessary.
		if ( minimumSignificantDigits - number.replace( /^0+|\./g, "" ).length > 0 ) {
			number = number.split( "." );
			number[ 1 ] = stringPad( number[ 1 ] || "", minimumSignificantDigits - number[ 0 ].replace( /^0+/, "" ).length, true );
			number = number.join( "." );
		}
	
		return number;
	};
	
	
	
	
	/**
	 * format( number, properties )
	 *
	 * @number [Number].
	 *
	 * @properties [Object] Output of number/format-properties.
	 *
	 * Return the formatted number.
	 * ref: http://www.unicode.org/reports/tr35/tr35-numbers.html
	 */
	var numberFormat = function( number, properties, pluralGenerator ) {
		var aux, compactMap, infinitySymbol, maximumFractionDigits, maximumSignificantDigits,
			minimumFractionDigits, minimumIntegerDigits, minimumSignificantDigits, nanSymbol,
			nuDigitsMap, padding, prefix, primaryGroupingSize, pattern, round, roundIncrement,
			secondaryGroupingSize, stringToParts, suffix, symbolMap;
	
		padding = properties[ 1 ];
		minimumIntegerDigits = properties[ 2 ];
		minimumFractionDigits = properties[ 3 ];
		maximumFractionDigits = properties[ 4 ];
		minimumSignificantDigits = properties[ 5 ];
		maximumSignificantDigits = properties[ 6 ];
		roundIncrement = properties[ 7 ];
		primaryGroupingSize = properties[ 8 ];
		secondaryGroupingSize = properties[ 9 ];
		round = properties[ 15 ];
		infinitySymbol = properties[ 16 ];
		nanSymbol = properties[ 17 ];
		symbolMap = properties[ 18 ];
		nuDigitsMap = properties[ 19 ];
		compactMap = properties[ 20 ];
	
		// NaN
		if ( isNaN( number ) ) {
			return [ { type: "nan", value: nanSymbol } ];
		}
	
		if ( number < 0 ) {
			pattern = properties[ 12 ];
			prefix = properties[ 13 ];
			suffix = properties[ 14 ];
		} else {
			pattern = properties[ 11 ];
			prefix = properties[ 0 ];
			suffix = properties[ 10 ];
		}
	
		// For prefix, suffix, and number parts.
		stringToParts = function( string ) {
			var numberType = "integer",
				parts = [];
	
			// TODO Move the tokenization of all parts that don't depend on number into
			// format-properties.
			string.replace( /('([^']|'')+'|'')|./g, function( character, literal ) {
	
				// Literals
				if ( literal ) {
					partsPush( parts, "literal", removeLiteralQuotes( literal ) );
					return;
				}
	
				// Currency symbol
				if ( character === "\u00A4" ) {
					partsPush( parts, "currency", character );
					return;
				}
	
				// Symbols
				character = character.replace( /[.,\-+E%\u2030]/, function( symbol ) {
					if ( symbol === "." ) {
						numberType = "fraction";
					}
					partsPush( parts, numberSymbolName[symbol], symbolMap[ symbol ] );
	
					// "Erase" handled character.
					return "";
				});
	
				// Number
				character = character.replace( /[0-9]/, function( digit ) {
	
					// Numbering system
					if ( nuDigitsMap ) {
						digit = nuDigitsMap[ +digit ];
					}
					partsPush( parts, numberType, digit );
	
					// "Erase" handled character.
					return "";
				});
	
				// Etc
				character.replace( /./, function( etc ) {
					partsPush( parts, "literal", etc );
				});
			});
			return parts;
		};
	
		prefix = stringToParts( prefix );
		suffix = stringToParts( suffix );
	
		// Infinity
		if ( !isFinite( number ) ) {
			return prefix.concat(
				{ type: "infinity", value: infinitySymbol },
				suffix
			);
		}
	
		// Percent
		if ( pattern.indexOf( "%" ) !== -1 ) {
			number *= 100;
	
		// Per mille
		} else if ( pattern.indexOf( "\u2030" ) !== -1 ) {
			number *= 1000;
		}
	
		var compactPattern, compactDigits, compactProperties, divisor, numberExponent, pluralForm;
	
		// Compact mode: initial number digit processing
		if ( compactMap ) {
			numberExponent = Math.abs( Math.floor( number ) ).toString().length - 1;
			numberExponent = Math.min( numberExponent, compactMap.maxExponent );
	
			// Use default plural form to perform initial decimal shift
			if ( numberExponent >= 3 ) {
				compactPattern = compactMap[ numberExponent ] && compactMap[ numberExponent ].other;
			}
	
			if ( compactPattern === "0" ) {
				compactPattern = null;
			} else if ( compactPattern ) {
				compactDigits = compactPattern.split( "0" ).length - 1;
				divisor = numberExponent - ( compactDigits - 1 );
				number = number / Math.pow( 10, divisor );
			}
		}
	
		// Significant digit format
		if ( !isNaN( minimumSignificantDigits * maximumSignificantDigits ) ) {
			number = numberFormatSignificantDigits( number, minimumSignificantDigits,
				maximumSignificantDigits, round );
	
		// Integer and fractional format
		} else {
			number = numberFormatIntegerFractionDigits( number, minimumIntegerDigits,
				minimumFractionDigits, maximumFractionDigits, round, roundIncrement );
		}
	
		// Compact mode: apply formatting
		if ( compactMap && compactPattern ) {
	
			// Get plural form after possible roundings
			pluralForm = pluralGenerator ? pluralGenerator( +number ) : "other";
	
			compactPattern = compactMap[ numberExponent ][ pluralForm ] || compactPattern;
			compactProperties = compactPattern.match( numberCompactPatternRe );
	
			// TODO Move the tokenization of all parts that don't depend on number into
			// format-properties.
			aux = function( string ) {
				var parts = [];
				string.replace( /(\s+)|([^\s0]+)/g, function( garbage, space, compact ) {
	
					// Literals
					if ( space ) {
						partsPush( parts, "literal", space );
						return;
					}
	
					// Compact value
					if ( compact ) {
						partsPush( parts, "compact", compact );
						return;
					}
				});
				return parts;
			};
	
			// update prefix/suffix with compact prefix/suffix
			prefix = prefix.concat( aux( compactProperties[ 1 ] ) );
			suffix = aux( compactProperties[ 3 ] ).concat( suffix );
		}
	
		// Remove the possible number minus sign
		number = number.replace( /^-/, "" );
	
		// Grouping separators
		if ( primaryGroupingSize ) {
			number = numberFormatGroupingSeparator( number, primaryGroupingSize,
				secondaryGroupingSize );
		}
	
		// Scientific notation
		// TODO implement here
	
		// Padding/'([^']|'')+'|''|[.,\-+E%\u2030]/g
		// TODO implement here
	
		return prefix.concat(
			stringToParts( number ),
			suffix
		);
	};
	
	
	
	
	var numberToPartsFormatterFn = function( properties, pluralGenerator ) {
		return function numberToPartsFormatter( value ) {
			validateParameterPresence( value, "value" );
			validateParameterTypeNumber( value, "value" );
	
			return numberFormat( value, properties, pluralGenerator );
		};
	};
	
	
	
	
	function validateDigits( properties ) {
		var minimumIntegerDigits = properties[ 2 ],
			minimumFractionDigits = properties[ 3 ],
			maximumFractionDigits = properties[ 4 ],
			minimumSignificantDigits = properties[ 5 ],
			maximumSignificantDigits = properties[ 6 ];
	
		// Validate significant digit format properties
		if ( !isNaN( minimumSignificantDigits * maximumSignificantDigits ) ) {
			validateParameterRange( minimumSignificantDigits, "minimumSignificantDigits", 1, 21 );
			validateParameterRange( maximumSignificantDigits, "maximumSignificantDigits",
				minimumSignificantDigits, 21 );
	
		} else if ( !isNaN( minimumSignificantDigits ) || !isNaN( maximumSignificantDigits ) ) {
			throw new Error( "Neither or both the minimum and maximum significant digits must be " +
				"present" );
	
		// Validate integer and fractional format
		} else {
			validateParameterRange( minimumIntegerDigits, "minimumIntegerDigits", 1, 21 );
			validateParameterRange( minimumFractionDigits, "minimumFractionDigits", 0, 20 );
			validateParameterRange( maximumFractionDigits, "maximumFractionDigits",
				minimumFractionDigits, 20 );
		}
	}
	
	/**
	 * .numberFormatter( [options] )
	 *
	 * @options [Object]:
	 * - style: [String] "decimal" (default) or "percent".
	 * - see also number/format options.
	 *
	 * Return a function that formats a number according to the given options and default/instance
	 * locale.
	 */
	Globalize.numberFormatter =
	Globalize.prototype.numberFormatter = function( options ) {
		var args, numberToPartsFormatter, returnFn;
	
		validateParameterTypePlainObject( options, "options" );
	
		options = options || {};
		args = [ options ];
	
		numberToPartsFormatter = this.numberToPartsFormatter( options );
		returnFn = numberFormatterFn( numberToPartsFormatter );
		runtimeBind( args, this.cldr, returnFn, [ numberToPartsFormatter ] );
	
		return returnFn;
	};
	
	/**
	 * .numberToPartsFormatter( [options] )
	 *
	 * @options [Object]:
	 * - style: [String] "symbol" (default), "accounting", "code" or "name".
	 * - see also number/format options.
	 *
	 * Return a function that formats a number to parts according to the given options and
	 * default/instance locale.
	 */
	Globalize.numberToPartsFormatter =
	Globalize.prototype.numberToPartsFormatter = function( options ) {
		var args, cldr, fnArgs, pattern, properties, returnFn;
	
		validateParameterTypePlainObject( options, "options" );
	
		options = options || {};
		cldr = this.cldr;
	
		args = [ options ];
	
		validateDefaultLocale( cldr );
	
		cldr.on( "get", validateCldr );
		try {
			if ( options.raw ) {
				pattern = options.raw;
			} else {
				pattern = numberPattern( options.style || "decimal", cldr );
			}
	
			properties = numberFormatProperties( pattern, cldr, options );
			fnArgs = [ properties ];
		} finally {
			cldr.off( "get", validateCldr );
		}
	
		validateDigits( properties );
	
		if ( options.compact ) {
			fnArgs.push( this.pluralGenerator() );
		}
		returnFn = numberToPartsFormatterFn.apply( null, fnArgs );
		runtimeBind( args, cldr, returnFn, fnArgs );
	
		return returnFn;
	};
	
	/**
	 * .numberParser( [options] )
	 *
	 * @options [Object]:
	 * - style: [String] "decimal" (default) or "percent".
	 *
	 * Return the number parser according to the default/instance locale.
	 */
	Globalize.numberParser =
	Globalize.prototype.numberParser = function( options ) {
		var args, cldr, pattern, properties, returnFn;
	
		validateParameterTypePlainObject( options, "options" );
	
		options = options || {};
		cldr = this.cldr;
	
		args = [ options ];
	
		validateDefaultLocale( cldr );
		if ( options.compact ) {
			throw createErrorUnsupportedFeature({
				feature: "compact number parsing (not implemented)"
			});
		}
	
		cldr.on( "get", validateCldr );
	
		if ( options.raw ) {
			pattern = options.raw;
		} else {
			pattern = numberPattern( options.style || "decimal", cldr );
		}
	
		properties = numberParseProperties( pattern, cldr, options );
	
		cldr.off( "get", validateCldr );
	
		returnFn = numberParserFn( properties );
	
		runtimeBind( args, cldr, returnFn, [ properties ] );
	
		return returnFn;
	};
	
	/**
	 * .formatNumber( value [, options] )
	 *
	 * @value [Number] number to be formatted.
	 *
	 * @options [Object]: see number/format-properties.
	 *
	 * Format a number according to the given options and default/instance locale.
	 */
	Globalize.formatNumber =
	Globalize.prototype.formatNumber = function( value, options ) {
		validateParameterPresence( value, "value" );
		validateParameterTypeNumber( value, "value" );
	
		return this.numberFormatter( options )( value );
	};
	
	/**
	 * .formatNumberToParts( value [, options] )
	 *
	 * @value [Number] number to be formatted.
	 *
	 * @options [Object]: see number/format-properties.
	 *
	 * Format a number to pars according to the given options and default/instance locale.
	 */
	Globalize.formatNumberToParts =
	Globalize.prototype.formatNumberToParts = function( value, options ) {
		validateParameterPresence( value, "value" );
		validateParameterTypeNumber( value, "value" );
	
		return this.numberToPartsFormatter( options )( value );
	};
	
	/**
	 * .parseNumber( value [, options] )
	 *
	 * @value [String]
	 *
	 * @options [Object]: See numberParser().
	 *
	 * Return the parsed Number (including Infinity) or NaN when value is invalid.
	 */
	Globalize.parseNumber =
	Globalize.prototype.parseNumber = function( value, options ) {
		validateParameterPresence( value, "value" );
		validateParameterTypeString( value, "value" );
	
		return this.numberParser( options )( value );
	};
	
	/**
	 * Optimization to avoid duplicating some internal functions across modules.
	 */
	Globalize._createErrorUnsupportedFeature = createErrorUnsupportedFeature;
	Globalize._numberNumberingSystem = numberNumberingSystem;
	Globalize._numberNumberingSystemDigitsMap = numberNumberingSystemDigitsMap;
	Globalize._numberPattern = numberPattern;
	Globalize._numberSymbol = numberSymbol;
	Globalize._looseMatching = looseMatching;
	Globalize._removeLiteralQuotes = removeLiteralQuotes;
	Globalize._stringPad = stringPad;
	Globalize._validateParameterTypeNumber = validateParameterTypeNumber;
	Globalize._validateParameterTypeString = validateParameterTypeString;
	
	return Globalize;
	
	
	
	
	}));


/***/ },

/***/ 126:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var assertion = __webpack_require__(60);
	
	// Load Globalize main module.
	var Globalize = __webpack_require__(58);
	
	// Extend Globalize with number and currency modules.
	__webpack_require__(121);
	
	var basic = __webpack_require__(57);
	var objectAssign = __webpack_require__(61);
	
	var assert = assertion.assert;
	var assertMetadata = assertion.assertMetadata;
	var assertRange = assertion.assertRange;
	var assertType = assertion.assertType;
	var getValueOrDefault = basic.getValueOrDefault;
	
	// Load functions shared with Node
	var numberHelpers = __webpack_require__(127);
	var assertCanonicalNumberType = numberHelpers.assertCanonicalNumberType;
	var assertLocalizedNumberType = numberHelpers.assertLocalizedNumberType;
	var setFractionDigits = numberHelpers.setFractionDigits;
	
	function assertRangeCurrencyCode(handler, parameter) {
	  assertRange(
	    parameter,
	    handler.metadata.cldrCurrencies,
	    'The ISO currency code `"{parameterValue}"` is invalid',
	    { parameterValue: parameter }
	  );
	}
	
	var NumberHandler = function() {};
	
	var optionsPrototype = {
	  parts: function() {
	    this.outputType = "parts";
	    return this;
	  },
	  currencyDisplay: function(currencyDisplay) {
	    this.currencyDisplay = currencyDisplay;
	    return this;
	  }
	};
	
	Object.defineProperty(NumberHandler.prototype, "NUMBER_FORMAT", {
	  get: function() {
	    return {
	      style: "decimal",
	      maximumFractionDigits: 9,
	      minimumFractionDigits: 0
	    };
	  },
	  enumerable: true
	});
	var NUMBER_FORMAT = NumberHandler.prototype.NUMBER_FORMAT;
	
	Object.defineProperty(NumberHandler.prototype, "NUMBER_FORMAT_PERCENT", {
	  get: function() {
	    return {
	      style: "percent",
	      maximumFractionDigits: 2,
	      minimumFractionDigits: 0
	    };
	  },
	  enumerable: true
	});
	
	// define currency presets on handler
	var CURRENCY_PRESETS = {
	  CURRENCY_FORMAT: "symbol",
	  CURRENCY_FORMAT_ISOCURRENCY: "code",
	  CURRENCY_FORMAT_SYMBOLISOCURRENCY: "international"
	};
	Object.keys(CURRENCY_PRESETS).forEach(function(presetName) {
	  Object.defineProperty(NumberHandler.prototype, presetName, {
	    get: function() {
	      var presetValue = CURRENCY_PRESETS[presetName];
	      return Object.create(optionsPrototype).currencyDisplay(presetValue);
	    },
	    enumerable: true
	  });
	});
	// get array of values for assertRange
	var CURRENCY_PRESET_VALUES = Object.keys(CURRENCY_PRESETS).map(function(
	  presetName
	) {
	  return CURRENCY_PRESETS[presetName];
	});
	
	/**
	 * formatNumber
	 */
	Object.defineProperty(NumberHandler.prototype, "formatNumber", {
	  value: function formatNumber(number, options) {
	    options = getValueOrDefault(options, NUMBER_FORMAT);
	    number = assertCanonicalNumberType(number, "number");
	    assertType(options, "options", ["plain object"]);
	    assert(
	      options.currencyDisplay === undefined,
	      "Invalid `options` property `currencyDisplay`. Use `.formatCurrency()` instead"
	    );
	    options = objectAssign({}, options);
	    setFractionDigits(options);
	    return this.globalize.formatNumber(number, options);
	  },
	  enumerable: true
	});
	
	/**
	 * normalizeNumber
	 */
	Object.defineProperty(NumberHandler.prototype, "normalizeNumber", {
	  value: function normalizeNumber(number, options) {
	    options = getValueOrDefault(options, NUMBER_FORMAT);
	    assertLocalizedNumberType(number, "number");
	    assertType(options, "options", ["plain object"]);
	    if (typeof number === "number") {
	      return number;
	    }
	    return this.globalize.parseNumber(number, options);
	  },
	  enumerable: true
	});
	
	function numberStyles(handler) {
	  return handler.metadata.cldrNumbers["symbols-numberSystem-latn"];
	}
	
	function symbolForCurrency(handler, currencyCode) {
	  var currencyMeta = handler.metadata.cldrCurrencies[currencyCode];
	  return currencyMeta && currencyMeta.symbol;
	}
	
	function currencyStyles(handler, currency) {
	  var newCurrencyStyles = {},
	    supportedStyles = [
	      "international",
	      "code",
	      "plural",
	      "separator",
	      "symbol"
	    ];
	  supportedStyles.forEach(function(style) {
	    newCurrencyStyles[style] = currencyPatternByStyle(
	      handler,
	      { currencyDisplay: style },
	      currency
	    );
	  });
	  return newCurrencyStyles;
	}
	
	function currencyPatternByStyle(handler, options, currency) {
	  var metadata = handler.metadata,
	    currencyStyles = metadata.currencyStyles,
	    didCurrencyLevelOverride = false; // set this to true if the style was overriden at the currency level
	
	  if (!options) {
	    options = { currencyDisplay: "symbol" };
	  }
	
	  var style = options.currencyDisplay;
	  var pattern = currencyStyles[style];
	
	  // Check if there's an override by currency (e.g. TRY) for this particular style and apply it
	  if (
	    currencyStyles.currency_override &&
	    currencyStyles.currency_override[currency] &&
	    currencyStyles.currency_override[currency][style]
	  ) {
	    pattern = currencyStyles.currency_override[currency][style];
	    didCurrencyLevelOverride = true; // set this flag so fuzzyMatch will be skipped
	  }
	
	  // if there was no override at the currency level
	  // and if this is the international style
	  // then apply fuzzyMatch
	  // basically: only apply fuzzyMatch to the vanilla international style
	  if (!didCurrencyLevelOverride && style === "international" && currency) {
	    var currencySymbol = symbolForCurrency(handler, currency);
	    if (!currencySymbol) {
	      return;
	    }
	    if (currencySymbol.length > 1) {
	      // call fuzzyMatch passing the currency Code MXN and currency Symbol $MX
	      var fuzzy = fuzzyMatch(currency, currencySymbol);
	      if (fuzzy >= 66) {
	        pattern = pattern.replace(/¤\s*/g, "");
	      }
	    }
	  }
	
	  return pattern;
	}
	
	/***
	 * @function
	 * @name     fuzzyMatch
	 * @input    it takes 2 strings valueA and valueB
	 * @returns  {number} the percentage of how similar are both
	 */
	function fuzzyMatch(svalueA, svalueB) {
	  if (svalueA === svalueB) {
	    return 100;
	  } else {
	    var valueA = svalueA.split(""),
	      valueB = svalueB.split(""),
	      equivalency = 0;
	    for (var i = 0; i < valueA.length; i++) {
	      if (valueB.indexOf(valueA[i]) !== -1) {
	        var position = valueB.indexOf(valueA[i]);
	        valueB.splice(position, 1);
	        equivalency++;
	      }
	    }
	    var weight = equivalency / valueA.length;
	    return weight * 100;
	  }
	}
	
	function digitsForCurrency(handler, currencyCode) {
	  return (
	    handler.metadata.currencyInfo[currencyCode] &&
	    handler.metadata.currencyInfo[currencyCode].digits
	  );
	}
	
	Object.defineProperty(NumberHandler.prototype, "formatCurrency", {
	  value: function formatCurrency(currency, options) {
	    var currencyCode, currencyValue;
	    options = getValueOrDefault(options, this.CURRENCY_FORMAT);
	
	    assertType(currency, "currency", ["plain object"]);
	    assertType(currency.currency, "currency.currency", ["string"]);
	    currencyValue = assertCanonicalNumberType(currency.value, "currency.value");
	    assertRangeCurrencyCode(this, currency.currency);
	
	    assertType(options, "options", ["plain object"]);
	    assertType(options.currencyDisplay, "options.currencyDisplay", ["string"]);
	    assertRange(
	      options.currencyDisplay,
	      CURRENCY_PRESET_VALUES,
	      'Invalid `options.currencyDisplay`: `"{parameterValue}"`',
	      { parameterValue: options.currencyDisplay }
	    );
	
	    currencyCode = currency.currency;
	    options = objectAssign({}, options);
	    var currencyDigits = digitsForCurrency(this, currencyCode);
	    setFractionDigits(options, currencyDigits);
	
	    var localeNumberStyles = numberStyles(this),
	      localeCurrencyStyles = currencyStyles(this, currencyCode),
	      symbol = symbolForCurrency(this, currencyCode),
	      formattedCurrency = "",
	      pattern = localeCurrencyStyles[options.currencyDisplay].split(";")[0];
	    if (options.outputType === "parts") {
	      formattedCurrency = [];
	    }
	
	    var formatBinder = function(key, value) {
	      if (options.outputType === "parts") {
	        var parts = { type: key, value: value };
	        formattedCurrency.push(parts);
	      } else {
	        formattedCurrency += value;
	      }
	    };
	
	    if (currencyValue < 0) {
	      pattern = localeCurrencyStyles[options.currencyDisplay].split(";")[1];
	      currencyValue = currencyValue * -1;
	    }
	    var numberOptions = NumberHandler.prototype.NUMBER_FORMAT;
	    numberOptions.maximumFractionDigits = options.maximumFractionDigits;
	    numberOptions.minimumFractionDigits = options.minimumFractionDigits;
	    var patternElements = {
	      "-": { key: "sign", value: localeNumberStyles.minusSign },
	      "¤": { key: "symbol", value: symbol },
	      "#": {
	        key: "value",
	        value: this.formatNumber(currencyValue, numberOptions)
	      },
	      C: { key: "code", value: currencyCode },
	      "\u00A0": { key: "separator", value: localeCurrencyStyles.separator }
	    };
	
	    for (var i = 0; i < pattern.length; i++) {
	      var part = patternElements[pattern.charAt(i)] || {
	        key: "literal",
	        value: pattern.charAt(i)
	      };
	      formatBinder(part.key, part.value);
	    }
	
	    return formattedCurrency;
	  },
	  enumerable: true
	});
	
	function assertNumberMeta(metadata) {
	  assertType(metadata, "metadata", ["plain object"]);
	  assertMetadata(metadata.cldr);
	  assertMetadata(metadata.cldr.main);
	  assertMetadata(metadata.cldr.supplemental);
	  assertMetadata(metadata.griffin);
	  assertMetadata(metadata.griffin.number);
	
	  var griffinNumberMeta = metadata.griffin.number;
	  assertMetadata(griffinNumberMeta.country, ["string"]);
	  assertMetadata(griffinNumberMeta.currencyInfo);
	  assertMetadata(griffinNumberMeta.currencyStyles);
	
	  // We assume the only key in 'main' is the locale.
	  var cldrLocale = Object.keys(metadata.cldr.main)[0];
	  assertMetadata(cldrLocale, ["string"]);
	  var cldrMain = metadata.cldr.main[cldrLocale];
	  assertMetadata(cldrMain);
	  var cldrNumbers = cldrMain.numbers;
	  assertMetadata(cldrNumbers);
	  assertMetadata(cldrNumbers["symbols-numberSystem-latn"]);
	  var cldrCurrencies = cldrNumbers.currencies;
	  assertMetadata(cldrCurrencies);
	  // assertMetadata(cldrCurrencies.styles); // now in griffin section
	}
	
	module.exports = {
	  // common createHandler code can be factored out and put in core
	  createHandler: function createHandler(metadata) {
	    // TODO validate metadata based on schema.
	    assertNumberMeta(metadata);
	
	    var handler = new NumberHandler();
	
	    // We assume the only key in 'main' is the locale.
	    var cldrLocale = Object.keys(metadata.cldr.main)[0];
	    var cldrMain = metadata.cldr.main[cldrLocale];
	    var cldrNumbers = cldrMain.numbers;
	    var cldrCurrencies = cldrNumbers.currencies;
	
	    var griffinNumberMeta = metadata.griffin.number;
	
	    // store particular parts of client metadata for use in the module
	    handler.metadata = {
	      country: griffinNumberMeta.country,
	      currencyStyles: griffinNumberMeta.currencyStyles,
	      currencyInfo: griffinNumberMeta.currencyInfo, // includes digits information
	      cldrNumbers: cldrNumbers,
	      cldrCurrencies: cldrCurrencies
	    };
	
	    // pass the cldr portion to Globalize
	    Globalize.load(metadata.cldr);
	    handler.globalize = Globalize(cldrLocale);
	
	    return handler;
	  }
	};


/***/ },

/***/ 127:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var assertion = __webpack_require__(60);
	var assertType = assertion.assertType;
	
	/**
	 * Asserts parameter type of a canonical number and type casts it into a Number
	 * Disallows empty string and NaN
	 * Used by Node
	 */
	function assertCanonicalNumberTypeStrict(parameterValue, parameterName) {
	  var number = parameterValue;
	  assertType(parameterValue, parameterName, [], {
	    // if number, should not be NaN
	    // if string, cast to Number and should not be NaN
	    condition:
	      (typeof parameterValue === "number" && !isNaN(parameterValue)) ||
	      (typeof parameterValue === "string" &&
	        parameterValue !== "" &&
	        !isNaN((number = Number(parameterValue)))),
	    errorMessage:
	      'Parameter `{parameterName}` must be a number or a string representing a canonical number (e.g, `"9999.99"`), not {parameterType} `{{parameterValue}}`'
	  });
	  return number;
	}
	
	/**
	 * Asserts parameter type of a canonical number and type casts it into a Number
	 * Disallows empty string but allows NaN
	 * Used by client
	 */
	function assertCanonicalNumberType(parameterValue, parameterName) {
	  var number = parameterValue;
	  assertType(parameterValue, parameterName, [], {
	    // if string, cast to Number and result should not be NaN
	    condition:
	      typeof parameterValue === "number" ||
	      (typeof parameterValue === "string" &&
	        parameterValue !== "" &&
	        !isNaN((number = Number(parameterValue)))),
	    errorMessage:
	      'Parameter `{parameterName}` must be a number or a string representing a canonical number (e.g, `"9999.99"`), not {parameterType} `{{parameterValue}}`'
	  });
	  return number;
	}
	
	/**
	 * Asserts parameter type of a localized number.
	 */
	function assertLocalizedNumberType(parameterValue, parameterName) {
	  assertType(parameterValue, parameterName, ["number", "string"], {
	    errorMessage:
	      'Parameter `{parameterName}` must be a number or a string representing a localized number (e.g., `"9,999.99"` in English or `"9.999,99"` in Spanish), not {parameterType} `{{parameterValue}}`'
	  });
	}
	
	/**
	 * Sets minimumFractionDigits/maximumFractionDigits in options:
	 *
	 * If either is undefined, currencyDigits is used (if provided)
	 * Otherwise, minimumFractionDigits defaults to 0, and maximumFractionDigits defaults to 9
	 * And if minimumFractionDigits is greater than maximumFractionDigits,
	 * then minimumFractionDigits is reduced to the same level as maximumFractionDigits
	 */
	function setFractionDigits(options, currencyDigits) {
	  // TODO: Use Globalize formatCurrency, which handles currency defaultDigits itself
	  if (options.minimumFractionDigits === undefined) {
	    options.minimumFractionDigits =
	      currencyDigits === undefined ? 0 : currencyDigits;
	  }
	  if (
	    options.maximumFractionDigits === undefined ||
	    options.maximumFractionDigits > 9
	  ) {
	    options.maximumFractionDigits =
	      currencyDigits === undefined ? 9 : currencyDigits;
	  }
	  if (options.minimumFractionDigits > options.maximumFractionDigits) {
	    options.minimumFractionDigits = options.maximumFractionDigits;
	  }
	  return options;
	}
	
	module.exports = {
	  assertCanonicalNumberType: assertCanonicalNumberType,
	  assertCanonicalNumberTypeStrict: assertCanonicalNumberTypeStrict,
	  assertLocalizedNumberType: assertLocalizedNumberType,
	  setFractionDigits: setFractionDigits
	};


/***/ },

/***/ 128:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = __webpack_require__(126);


/***/ },

/***/ 133:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var $ = __webpack_require__(65);
	var FormattedHTMLMessage = __webpack_require__(6).FormattedHTMLMessage;
	var i18n = __webpack_require__(2);
	var Analytics = __webpack_require__(3);
	var griffinKeyCreator = __webpack_require__(55).griffinKeyCreator;
	var ReactCSSTransitionGroup = __webpack_require__(163);
	
	var FEATURES_KEYS_PREFIX = 'fees.feature.';
	var FEATURES_KEYS = ['no_fees', 'free_direct_deposit', 'free_withdrawals', 'load_cash'];
	
	var TABLE_KEYS_PREFIX = 'fees.table.';
	var TABLE_HEADERS_KEYS = ['all_fees', 'amount', 'details'];
	var TABLE_DETAILS_KEYS_SUFFIX = ['.name', '.amount', '.details'];
	var TABLE_HEADERS_KEYS_SUFFIX = '.header';
	
	var v2ContentKeys = ['fees.table.spend_money.cash_card_purchases.name', 'fees.table.spend_money.cash_card_purchases.details', 'fees.table.add_money.load_cash_using_cash_card.name'];
	
	var FeesPage = React.createClass({
	    displayName: 'FeesPage',
	
	    mixins: [i18n('common/fees')],
	
	    propTypes: {
	        griffin: React.PropTypes.object.isRequired,
	        dailyLimit: React.PropTypes.string.isRequired,
	        monthlyLimit: React.PropTypes.string.isRequired,
	        isCFPBCardPlusContentFlagEnabled: React.PropTypes.bool,
	        instanceLocation: React.PropTypes.object.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return { isBackToTopButtonVisible: false };
	    },
	
	    componentDidMount: function componentDidMount() {
	        document.title = 'PayPal: ' + this.i18nWithCardConfig('fees.header_v2');
	        Analytics.trackPage({ id: 'fees', data: this.props });
	        window.addEventListener('scroll', this.setBackToTopButtonVisibility);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        window.removeEventListener('scroll', this.setBackToTopButtonVisibility);
	    },
	
	    setBackToTopButtonVisibility: function setBackToTopButtonVisibility() {
	        var isBackToTopButtonVisible = this.feesPageContainer.getBoundingClientRect().top < 0;
	
	        this.setState({
	            isBackToTopButtonVisible: isBackToTopButtonVisible
	        });
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.isBackToTopButtonVisible !== this.state.isBackToTopButtonVisible;
	    },
	
	    backToTop: function backToTop(event) {
	        event.preventDefault();
	        $('html, body').animate({ scrollTop: 0 }, 500);
	    },
	
	    renderBackToTop: function renderBackToTop() {
	        var button = React.createElement(
	            'div',
	            { key: 'backToTop', onClick: this.backToTop, className: 'vx_btn vx_btn-medium terms-back-to-top-btn' },
	            this.i18n('fees.backToTop')
	        );
	
	        return React.createElement(
	            ReactCSSTransitionGroup,
	            {
	                transitionName: 'backToTopButton',
	                transitionEnterTimeout: 500,
	                transitionLeaveTimeout: 500
	            },
	            this.state.isBackToTopButtonVisible && button
	        );
	    },
	
	    // Content layout
	    renderHeader: function renderHeader() {
	        return React.createElement(
	            'header',
	            { className: 'vx_modal-header text-center' },
	            React.createElement(
	                'h2',
	                { className: 'fees-header vx_h2' },
	                this.i18nWithCardConfig('fees.header_v2')
	            )
	        );
	    },
	
	    renderSubheader: function renderSubheader() {
	        return React.createElement(
	            'h3',
	            { className: 'fees-subheader text-center vx_h3' },
	            this.i18n('fees.subheader')
	        );
	    },
	
	    renderCheckmark: function renderCheckmark() {
	        return React.createElement('i', { className: 'icon icon-circled-checkmark-small fees-green-checkmark' });
	    },
	
	    renderFeaturesTable: function renderFeaturesTable() {
	        var i18n = this.i18n;
	        var checkmark = this.renderCheckmark();
	
	        var featuresContent = FEATURES_KEYS.map(function (i) {
	            var propKey = FEATURES_KEYS_PREFIX + i;
	            return React.createElement(
	                'tr',
	                { key: propKey },
	                React.createElement(
	                    'td',
	                    null,
	                    checkmark
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    i18n(propKey)
	                )
	            );
	        });
	
	        return React.createElement(
	            'table',
	            { className: 'fees-features-table' },
	            React.createElement(
	                'tbody',
	                null,
	                featuresContent
	            )
	        );
	    },
	
	    renderFeesTable: function renderFeesTable() {
	        var _this = this;
	
	        var i18n = this.i18n;
	
	        var _griffinKeyCreator = griffinKeyCreator(this.props.griffin.griffinNumber),
	            insertLocalisedPercentageProperty = _griffinKeyCreator.insertLocalisedPercentageProperty,
	            insertLocalisedCurrencyProperty = _griffinKeyCreator.insertLocalisedCurrencyProperty;
	
	        var currencyAmts = ['0', '2.50', '3.00', '3.95', '4.95', '5.00', '400', '500', '3000', '4000'].reduce(function (acc, cur) {
	            return insertLocalisedCurrencyProperty(acc, cur);
	        }, {});
	        var percentages = [1, 2.5, 5].reduce(function (acc, cur) {
	            return insertLocalisedPercentageProperty(acc, cur);
	        }, {});
	        var griffinInterpolations = _extends({}, currencyAmts, percentages);
	
	        var isCFPBCardPlusContentFlagEnabled = this.props.isCFPBCardPlusContentFlagEnabled;
	        var headers = React.createElement(
	            'tbody',
	            null,
	            React.createElement(
	                'tr',
	                null,
	                TABLE_HEADERS_KEYS.map(function (i) {
	                    var propKey = TABLE_KEYS_PREFIX + i + TABLE_HEADERS_KEYS_SUFFIX;
	                    return React.createElement(
	                        'th',
	                        { className: 'fees-table-main-heading', key: propKey },
	                        ' ',
	                        i18n(propKey),
	                        ' '
	                    );
	                })
	            )
	        );
	
	        var generateDetailsHeader = function generateDetailsHeader(groupName) {
	            return React.createElement(
	                'tr',
	                null,
	                React.createElement(
	                    'th',
	                    { className: 'fees-table-sub-heading', colSpan: '3' },
	                    i18n(TABLE_KEYS_PREFIX + groupName + TABLE_HEADERS_KEYS_SUFFIX),
	                    ' '
	                )
	            );
	        };
	
	        var generateDetailsRow = function generateDetailsRow(groupName, rowName) {
	            var propKeyPrefix = TABLE_KEYS_PREFIX + groupName + '.' + rowName;
	
	            var tableKeySuffix = TABLE_DETAILS_KEYS_SUFFIX;
	            if (isCFPBCardPlusContentFlagEnabled && (rowName === 'load_cash_using_app' || rowName === 'load_cash_using_cash_card')) {
	                tableKeySuffix = ['.name', '.amount', '.cash_plus.details'];
	            }
	            return React.createElement(
	                'tr',
	                { key: propKeyPrefix },
	                tableKeySuffix.map(function (i) {
	                    var propKey = propKeyPrefix + i;
	                    propKey = propKey === 'fees.table.add_money.load_cash_using_cash_card.cash_plus.details' || propKey === 'fees.table.add_money.load_cash_using_app.cash_plus.details' ? propKey + '_rebranding' : propKey;
	                    if (v2ContentKeys.includes(propKey)) {
	                        propKey += '_v2';
	                    }
	                    return React.createElement(
	                        'td',
	                        { key: propKey },
	                        React.createElement(FormattedHTMLMessage, {
	                            message: _this.i18nWithCardConfig(propKey, griffinInterpolations)
	                        })
	                    );
	                })
	            );
	        };
	
	        var generateGroup = function generateGroup(groupName, rowNameList) {
	            return React.createElement(
	                'tbody',
	                { key: groupName },
	                generateDetailsHeader(groupName),
	                rowNameList.map(function (rowName) {
	                    return generateDetailsRow(groupName, rowName);
	                })
	            );
	        };
	
	        var groupCashLoads = React.createElement(
	            'tbody',
	            { key: 'cash_load' },
	            generateDetailsHeader('cash_load'),
	            React.createElement(
	                'tr',
	                { key: 'fees.table.cash_load.daily' },
	                React.createElement(
	                    'td',
	                    null,
	                    i18n('fees.table.cash_load.daily.name')
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    this.props.dailyLimit
	                ),
	                React.createElement(
	                    'td',
	                    { rowSpan: '2' },
	                    React.createElement(FormattedHTMLMessage, { message: i18n('fees.table.cash_load.daily_monthly.details', { dailyLimit: this.props.dailyLimit, monthlyLimit: this.props.monthlyLimit }) })
	                )
	            ),
	            React.createElement(
	                'tr',
	                { key: 'fees.table.cash_load.monthly' },
	                React.createElement(
	                    'td',
	                    null,
	                    i18n('fees.table.cash_load.monthly.name')
	                ),
	                React.createElement(
	                    'td',
	                    null,
	                    this.props.monthlyLimit
	                )
	            )
	        );
	
	        return React.createElement(
	            'table',
	            null,
	            headers,
	            generateGroup('get_started', ['card_fee']),
	            generateGroup('monthly_usage', ['monthly_fee', 'inactivity']),
	            generateGroup('add_money', ['load_cash_using_app', 'load_cash_using_cash_card', 'direct_deposit', 'transfer', 'receive', 'check_cashed', 'check_cashing_payroll_gov', 'check_cashing_others']),
	            generateGroup('spend_money', ['cash_card_purchases']),
	            generateGroup('declined_trans', ['spending_declined', 'atm_declined']),
	            generateGroup('withdrawals', ['in_network_atm', 'out_network_atm', 'bank_counter']),
	            generateGroup('usage_limits', ['daily_atm', 'daily_purchase']),
	            generateGroup('outside_us', ['international_transaction', 'interational_atm']),
	            generateGroup('processing_policies', ['negative_balance', 'card_replacement_std']),
	            generateGroup('sending_money', ['send_from_ppbalance']),
	            groupCashLoads
	        );
	    },
	
	    renderFooter: function renderFooter() {
	        return React.createElement(
	            'div',
	            null,
	            React.createElement(
	                'div',
	                { className: 'vx_text-body_secondary' },
	                React.createElement(FormattedHTMLMessage, { message: this.i18nWithCardConfig('fee.footer.about_trems_v2') })
	            ),
	            React.createElement('br', null),
	            React.createElement(
	                'div',
	                { className: 'vx_text-body_secondary' },
	                React.createElement(FormattedHTMLMessage, { message: this.i18nWithCardConfig('fees.footer.about_ppcashcard_v2') })
	            ),
	            React.createElement('br', null),
	            React.createElement(
	                'div',
	                { className: 'vx_text-body_secondary' },
	                React.createElement(FormattedHTMLMessage, { message: this.i18nWithCardConfig('fees.footer.about_debit_benefits_v2') })
	            )
	        );
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var cdnHostName = this.props.instanceLocation.cdnHostName;
	
	        return React.createElement(
	            'div',
	            { className: 'fees-page vx_modal-content', id: 'fees-page', ref: function ref(e) {
	                    _this2.feesPageContainer = e;
	                } },
	            this.renderHeader(),
	            this.renderSubheader(),
	            React.createElement(
	                'div',
	                { className: 'fees-image-features-container' },
	                React.createElement(
	                    'div',
	                    { className: 'fees-image-left' },
	                    React.createElement('img', { src: 'https://' + cdnHostName + '/ucs/placeholder/cons-debit-card-with-app.png', alt: '' })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'fees-features-right' },
	                    this.renderFeaturesTable()
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'fees-table-container' },
	                this.renderFeesTable()
	            ),
	            this.renderFooter(),
	            this.renderBackToTop()
	        );
	    }
	});
	
	module.exports = FeesPage;
	/* eslint i18n-scan/no-inline-concatenation: 0 */

/***/ },

/***/ 328:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var FeesPage = __webpack_require__(133);
	var GriffinNumber = __webpack_require__(128);
	
	var RootComponent = React.createClass({
	    displayName: 'RootComponent',
	
	    propTypes: {
	        renderCurrentPage: React.PropTypes.func.isRequired,
	        griffinMetadata: React.PropTypes.object.isRequired,
	        section: React.PropTypes.string,
	        dailyLimit: React.PropTypes.string.isRequired,
	        monthlyLimit: React.PropTypes.string.isRequired,
	        isCFPBCardPlusContentFlagEnabled: React.PropTypes.bool,
	        instanceLocation: React.PropTypes.object.isRequired,
	        remoteConfig: React.PropTypes.object.isRequired
	    },
	
	    render: function render() {
	        var griffin = {
	            griffinNumber: GriffinNumber.createHandler(this.props.griffinMetadata)
	        };
	
	        return this.props.renderCurrentPage({
	            section: this.props.section,
	            griffin: griffin,
	            dailyLimit: this.props.dailyLimit,
	            monthlyLimit: this.props.monthlyLimit,
	            isCFPBCardPlusContentFlagEnabled: this.props.isCFPBCardPlusContentFlagEnabled,
	            instanceLocation: this.props.instanceLocation,
	            remoteConfig: this.props.remoteConfig
	        });
	    }
	});
	
	RootComponent.getFlowProps = function () {
	    return {
	        startPage: FeesPage,
	        terminalPages: [FeesPage],
	        hideFeedbackLink: [FeesPage]
	    };
	};
	
	module.exports = RootComponent;

/***/ }

});


/** WEBPACK FOOTER **
 ** fees.js
 **/